/*  OmniStudio configurator — colour-flow orchestrator.
    Extracted verbatim from sections/omnitub-configurator.liquid (was a position-
    critical INLINE <script>). Loaded as a PLAIN external script (NO defer / NO async)
    at the SAME DOM position, so it still executes synchronously in document order —
    the buy-box takeover (MutationObserver hoist) and window.OMN_CFG[SID] registration
    keep their original timing, which the deferred omni-waste.js depends on.

    The single Liquid value (section.id) is handed in by a tiny inline shim that pushes
    each instance's SID onto window.__OMN_CFG.q; this script drains one SID per <script
    src> execution, preserving exact per-instance, in-order, synchronous boot. NO Liquid
    in this file. */
(function(){
  window.__OMN_CFG = window.__OMN_CFG || {};
  var q = window.__OMN_CFG.q = window.__OMN_CFG.q || [];
  // One SID was just enqueued by the inline shim immediately preceding this <script src>.
  // Drain exactly that one (drain-all is harmless if a prior tag missed, but in document
  // order each src tag pairs with the shim before it).
  function boot(SID){
    // ── Seamless stepped builder flag ───────────────────────────────────────────
    //   Folds the waste step into THIS overlay as step ②. Default OFF so live shoppers
    //   keep the current flow; ?omn_seam=1 forces ON for verification, ?omn_seam=0 forces
    //   OFF. Flip OMN_SEAM_DEFAULT → true to ship the stepped builder to everyone.
    var OMN_SEAM_DEFAULT = true;   // ON for all shoppers (verified e2e 7 Jun); ?omn_seam=0 forces the old flow
    var SEAMLESS = /[?&]omn_seam=1/.test(location.search) ? true
                 : (/[?&]omn_seam=0/.test(location.search) ? false : OMN_SEAM_DEFAULT);
    // wastes: single-step — choose finish/colour, add, done (panels pattern; no step-2)
    var dataEl = document.getElementById('omn-cfg-data-'+SID);
    var D; try { D = JSON.parse(dataEl.textContent); } catch(e){ return; }
    var overlay = document.getElementById('omn-cfg-overlay-'+SID);
    var trigger = document.getElementById('omn-cfg-trigger-'+SID);
    if (!overlay || !trigger) return;

    // P0 render-complexity fix (3 Aug 2026): the rest of boot needs D.variants. For
    // <250-variant products it is inline; for 437-colour products it is lazy-fetched
    // (see the dispatch at the end of boot) so the 32KB index never loads this PDP.
    function __bootRest(){

    // ── variant_index shape normaliser (fixes the "£NaN" price-foot bug) ─────────
    //   Rows arrive EITHER as objects {id,value,price,available,sku} (the inline
    //   ≤250-variant Liquid fallback) OR as compact positional arrays
    //   [id, price, available, value, sku] (the configurator.variant_index metafield
    //   written by write_variant_index.py). Everything below reads v.value / v.price /
    //   v.sku as OBJECT fields, so an un-normalised array leaves white=null and every
    //   price undefined → money(undefined) → "£NaN" in the price foot on the Solo (and
    //   any metafield-indexed) PDP. Normalise arrays → objects, in place, once.
    if (D && Array.isArray(D.variants)) {
      D.variants = D.variants.map(function (v) {
        return Array.isArray(v) ? { id: v[0], price: v[1], available: !!v[2], value: v[3], sku: v[4] } : v;
      });
    }
    // ── LIVE PRICES (5 Oct 2026 user test: the waste sheet showed £95/£143 while the page
    //   said £90/£135). The precomputed variant_index metafield snapshots prices at write
    //   time, so a sale price-cut (or its revert) leaves every row stale. D.live carries the
    //   LIVE price of the first ≤250 variants from Liquid; rows beyond that (e.g. Omnitone
    //   RAL variants) take the live price of their stale price class — variants that shared
    //   a price when the index was written still share one now (sales move whole classes).
    if (D && Array.isArray(D.live) && Array.isArray(D.variants) && D.live.length) {
      var __live = {}, __cls = {};
      D.live.forEach(function (r) { if (r && r.length > 1) __live[String(r[0])] = r[1]; });
      D.variants.forEach(function (v) {
        var lp = __live[String(v.id)];
        if (lp != null && v.price != null && !(v.price in __cls)) __cls[v.price] = lp;
      });
      D.variants.forEach(function (v) {
        var lp = __live[String(v.id)];
        if (lp != null) v.price = lp;
        else if (v.price != null && (v.price in __cls)) v.price = __cls[v.price];
      });
    }
    // RAL swatch sprite (RAL licence §2(2): chips paint from an IMAGE, not a published
    // hex table; the tint hex is sampled from the same-origin sprite — see omn-swatch.js).
    if (window.OmnSwatch && D && D.spriteUrl) OmnSwatch.cfg(D.spriteUrl, D.spriteCols, D.spriteRows);

    // ── REAL-COLOUR cutout studio (SHOWER TRAYS) ─────────────────────────────────
    //   Swap the white-base + CSS-tint for the ACTUAL rendered cutout per colour+angle
    //   (cutout/<key>/<variant.sku>.png, transparent bg). Flag-gated: ?omn_realcolour=1
    //   forces ON, =0 forces OFF; flip OMN_REALCOLOUR_DEFAULT → true to ship to everyone.
    var OMN_REALCOLOUR_DEFAULT = true;    // LIVE — verified on preview + signed off 19 Jun 2026 (top/¾/low; side/end/feet auto-join)
    var REALCOLOUR = /[?&]omn_realcolour=1/.test(location.search) ? true
                   : (/[?&]omn_realcolour=0/.test(location.search) ? false : OMN_REALCOLOUR_DEFAULT);
    var CUT = D.cutout || null;
    if(!CUT || !CUT.angles || !CUT.angles.length) REALCOLOUR = false;   // non-trays / no cutouts → never engage
    // The default/white view uses the RAL 9003 Signal White cutout (it has a real render).
    var WHITE_SKU = (function(){ var vs=D.variants||[]; for(var i=0;i<vs.length;i++){ if(/9003|signal white/i.test((vs[i].value||''))) return vs[i].sku||''; } return ''; })();

    var $ = function(id){ return document.getElementById(id+'-'+SID); };
    var trigSw=$('omn-cfg-trig-sw'), trigVal=$('omn-cfg-trig-val');
    var famWrap=$('omn-cfg-fams'), grid=$('omn-cfg-grid'), loading=$('omn-cfg-loading');
    var searchGrid=$('omn-cfg-search'), refInput=$('omn-cfg-ref'), bespokeInput=$('omn-cfg-bespoke');
    var selChip=$('omn-cfg-self-chip'), selName=$('omn-cfg-self-name'), selMeta=$('omn-cfg-self-meta');
    var priceEl=$('omn-cfg-price'), addBtn=$('omn-cfg-add');
    var tintColor=$('omn-cfg-tint-color'), tintMult=$('omn-cfg-tint-mult'),
        pvDot=$('omn-cfg-pv-dot'), pvName=$('omn-cfg-pv-name'), pvCode=$('omn-cfg-pv-code'), pvCap=$('omn-cfg-pv-cap');
    var previewFig=overlay.querySelector('.omn-cfg__preview-fig'),
        previewImg=overlay.querySelector('.omn-cfg__preview-img');
    var tabs=overlay.querySelectorAll('.omn-cfg__tab'), panes=overlay.querySelectorAll('.omn-cfg__panel-pane');
    var methodSel=$('omn-cfg-method'), familySel=null, famGroup=$('omn-cfg-famgroup');   // ONE combined filter (method + families merged)
    var qInput=$('omn-cfg-q'), qClose=$('omn-cfg-qclose'), qCount=$('omn-cfg-qcount');
    var searchWrap=$('omn-cfg-searchwrap'), qToggles=overlay.querySelectorAll('.omn-cfg__search-toggle');
    var browsePane=overlay.querySelector('.omn-cfg__panel-pane[data-pane="browse"]');
    var activeQuery='';   // live search across the browse grid

    function norm(s){ return (s||'').toString().trim().toLowerCase(); }
    // ── forgiving search: UK/US + common variants, then a fuzzy "did you mean" pass ──
    var searchCorrected='';
    var SPELL={gray:'grey',grays:'greys',color:'colour',colors:'colours',colored:'coloured',
      coloured:'coloured',aluminum:'aluminium',grey:'grey',whte:'white',gold:'gold'};
    function canon(s){ return norm(s).replace(/[^a-z0-9 ]+/g,' ').split(/\s+/)
      .map(function(w){return SPELL[w]||w;}).filter(Boolean).join(' '); }
    var _vocab=null;
    function vocab(){ if(_vocab) return _vocab; _vocab={};
      (COLOURS||[]).forEach(function(c){ canon(c.name).split(' ').forEach(function(w){ if(w.length>=3) _vocab[w]=1; }); });
      return _vocab; }
    function lev(a,b){ var m=a.length,n=b.length; if(!m)return n; if(!n)return m;
      var d=[],i,j; for(i=0;i<=m;i++)d[i]=[i]; for(j=0;j<=n;j++)d[0][j]=j;
      for(i=1;i<=m;i++)for(j=1;j<=n;j++){ var c=a.charAt(i-1)===b.charAt(j-1)?0:1;
        d[i][j]=Math.min(d[i-1][j]+1,d[i][j-1]+1,d[i-1][j-1]+c); } return d[m][n]; }
    function correctToken(t){ if(t.length<3) return t; var v=vocab(); if(v[t]) return t;
      var best=t,bd=99,thr=(t.length<=4?1:2); for(var w in v){ var d=lev(t,w); if(d<bd){bd=d;best=w;} }
      return bd<=thr?best:t; }
    function matchTokens(c,toks){
      if(!c._h){ c._h=canon(c.name)+' '+norm(c.code)+' '+norm(c.system); }   // canon ONCE per colour, cached (was per-keystroke = slow)
      var hay=c._h;
      return toks.every(function(t){ return hay.indexOf(t)>-1; }); }
    function esc(s){ return (window.CSS&&CSS.escape)?CSS.escape(s):String(s).replace(/["\\]/g,'\\$&'); }
    function codeLabel(){ var c=sel.code||'', s=sel.system||'';
      if(!c) return s;
      return (s && norm(c).indexOf(norm(s))===0) ? c : (s ? s+' '+c : c); }
    function money(c){
      var f=(D.moneyFormat||'£{{amount}}').replace(/<[^>]*>/g,'');
      var v=(c/100).toLocaleString('en-GB',{minimumFractionDigits:2,maximumFractionDigits:2});
      var v0=(c/100).toLocaleString('en-GB',{minimumFractionDigits:0,maximumFractionDigits:0});
      return f.replace(/\{\{\s*amount\s*\}\}/g,v).replace(/\{\{\s*amount_no_decimals\s*\}\}/g,v0)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,v).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,v0);
    }

    // variant maps
    var byValue={}, white=null, custom=null, firstColoured=null;
    (D.variants||[]).forEach(function(v){
      var k=norm(v.value);
      if(!(k in byValue)) byValue[k]=v;
      if(k==='white'&&!white) white=v;
      if((k.indexOf('custom colour')>-1||k.indexOf('custom color')>-1)&&!custom) custom=v;
      if(k!=='white'&&!firstColoured) firstColoured=v;
    });
    var colouredFallback = custom||firstColoured||white||(D.variants||[])[0]||null;
    // ── WASTE MODE ── the standard metal finishes pin first (like White on tubs);
    //    colour picks resolve to the EXACT named Omnitone variant (sku -> R2 render).
    var WASTE = !!D.wasteMode;
    var FINISHES = WASTE ? (D.finishes||[]).filter(function(f){ return byValue[norm(f.value)]; }) : [];
    // ── EXACT NAMED VARIANT (all products) ── a palette pick resolves to the real
    //    systematic variant ("RAL 6009 Fir Green" / "BS 4800 00 A 01 Ash Grey") on
    //    tubs, Sheer, trays, panels AND wastes — so the chosen colour rides the
    //    variant itself through cart → checkout → order confirmation → packing
    //    slips. Bare legacy names ("Antelope") still hit via byValue; Custom is
    //    the last resort (true bespoke/reference picks only).
    function namedColourVariant(){
      if(sel.mode!=='palette') return null;
      var code=sel.code||''; if(!code) return null;
      var sysn=norm(sel.system);
      var full=(sysn==='ral' ? code : ('BS 4800 '+code))+' '+(sel.name||'');
      return byValue[norm(full)]||null;
    }
    function wasteColourVariant(){ return WASTE ? namedColourVariant() : null; }
    // ── AUTO-MATCH (the final piece) ── the tub/tray studios remember the
    //    customer's chosen colour (localStorage, 30 days); on a waste we pin
    //    that exact colour FIRST as a one-tap "YOUR COLOUR" swatch that
    //    resolves to the real Omnitone variant (price and all).
    var MATCH=null;
    if(WASTE){ try{
      var _m=JSON.parse(localStorage.getItem('omn_last_colour')||'null');
      if(_m && _m.code && _m.name && (Date.now()-(_m.t||0)) < 2592000000){
        var _mf=(norm(_m.system)==='ral' ? _m.code : ('BS 4800 '+_m.code))+' '+_m.name;
        if(byValue[norm(_mf)]) MATCH=_m;
      }
    }catch(_e){} }
    var basePrice = white ? white.price : (colouredFallback?colouredFallback.price:0);
    var colourPrice = colouredFallback ? colouredFallback.price : basePrice;

    // selection state
    var sel = { mode:'palette', name:'White', code:'00 E 55', system:'BS4800', hex:'#FFFFFF', ref:'', note:'' };
    // WASTE default (5 Oct 2026): open on the "from" finish — the cheapest standard finish
    //   (Chrome), the one the card's "from £" quotes — never on whichever variant sits first
    //   (Brushed Brass). An explicit ?variant= deep link to a standard finish wins.
    var URL_VARIANT = (location.search.match(/[?&]variant=(\d+)/)||[])[1] || '';
    function wasteDefaultFinish(){
      if(URL_VARIANT){ for(var i=0;i<FINISHES.length;i++){ var uv=byValue[norm(FINISHES[i].value)]; if(uv && String(uv.id)===URL_VARIANT) return FINISHES[i]; } }
      var best=null, bp=Infinity;
      FINISHES.forEach(function(f){ var v=byValue[norm(f.value)]; if(v && v.price!=null && v.price<bp){ bp=v.price; best=f; } });
      return best||FINISHES[0];
    }
    if(WASTE && FINISHES.length){
      // "from" finish leads the strip so the chosen swatch is visible on open (stable sort by live price)
      FINISHES = FINISHES.map(function(f,i){ var v=byValue[norm(f.value)]; return {f:f,i:i,p:(v&&v.price!=null)?v.price:Infinity}; })
        .sort(function(a,b){ return (a.p-b.p)||(a.i-b.i); }).map(function(x){ return x.f; });
      sel = { mode:'finish', name:wasteDefaultFinish().value, code:'', system:'', hex:'', ref:'', note:'' };
    }
    // A finish with no photo gets a tone from its name, never a blank chip.
    function finishTone(name){ var n=norm(name);
      if(n.indexOf('brass')>-1) return 'linear-gradient(135deg,#d9c48a,#a8873f)';
      if(n.indexOf('bronze')>-1) return 'linear-gradient(135deg,#9a6b45,#5c3b22)';
      if(n.indexOf('copper')>-1) return 'linear-gradient(135deg,#c9825a,#8a4a2b)';
      if(n.indexOf('gold')>-1) return 'linear-gradient(135deg,#e6cf8a,#b38f3a)';
      if(n.indexOf('black')>-1) return 'linear-gradient(135deg,#4a4a4a,#111)';
      if(n.indexOf('white')>-1) return 'linear-gradient(135deg,#ffffff,#e6e6e2)';
      if(n.indexOf('gunmetal')>-1||n.indexOf('graphite')>-1) return 'linear-gradient(135deg,#6b6e72,#35383c)';
      return 'linear-gradient(135deg,#f4f5f6,#b9bdc2)'; }   // chrome / stainless / nickel
    var COLOURS=[], FAMILIES=[];
    var bgPickMode=false;   // when true, the swatch grid sets the BACKDROP, not the tub finish

    function resolve(){
      var props={}, target=colouredFallback, drv=null, label='', price=colourPrice, isWhite=false;
      if(WASTE && sel.mode==='finish'){
        var fv=byValue[norm(sel.name)];
        if(fv){ return { variant:fv, props:{}, drv:fv.value, label:sel.name, price:fv.price, isWhite:false }; }
      }
      if(sel.mode==='palette'){
        label=sel.name||'White';
        if(norm(sel.name)==='white'&&white){ target=white; drv=white.value; price=white.price; isWhite=true; }
        else if(namedColourVariant()){ target=namedColourVariant(); drv=target.value; price=target.price; }
        else if(byValue[norm(sel.name)]){ target=byValue[norm(sel.name)]; drv=target.value; price=target.price; }
        else { target=colouredFallback; drv=target?target.value:null; price=colourPrice;
               var cl=codeLabel(); props['Requested colour']=(cl?cl+' ':'')+sel.name; }
      } else if(sel.mode==='reference'){
        label=sel.ref||'your reference'; target=colouredFallback; drv=target?target.value:null; price=colourPrice;
        props['Paint reference']=sel.ref;
      } else {
        label='your bespoke colour'; target=colouredFallback; drv=target?target.value:null; price=colourPrice;
        props['Bespoke match']=sel.note;
      }
      return { variant:target, props:props, drv:drv, label:label, price:price, isWhite:isWhite };
    }

    // ── Bespoke-colour image journey ────────────────────────────────────────────
    //   Composite the chosen finish onto the grounded render (the SAME masked-multiply
    //   the live preview uses) on a <canvas>, upload the JPEG to the render host, and
    //   return its URL so it can ride the line item through cart → checkout → order
    //   email → delivery tracking. Palette colours only (white / reference / bespoke
    //   have no hex to render). Best-effort: it NEVER blocks the add — a failure or a
    //   >2.5s wait resolves to null and the item still adds (the property is just absent).
    var OMN_RENDER_UPLOAD = 'https://omnitub-render-images.morning-flower-fb25.workers.dev/upload';
    function omnLoadImg(src){ return new Promise(function(res,rej){ var i=new Image(); i.crossOrigin='anonymous'; i.onload=function(){res(i);}; i.onerror=rej; i.src=src; }); }
    function colourImageProp(r){
      try{
        if(sel.mode!=='palette' || r.isWhite) return Promise.resolve(null);
        var hex=(sel.hex||''); if(!hex || hex.toUpperCase()==='#FFFFFF') return Promise.resolve(null);
        // Tubs carry preview_renders; PANELS carry preview_masks_by_style (own style
        // first) — fall back to its base+mask so panel lines also get a coloured
        // render image (_colour_image) for the cart / order emails / tracking.
        var PR=D.previewRenders, rec=null;
        if(PR && PR.length){ rec={src:PR[0].src, mask:PR[0].mask||PR[0].src}; }
        else if(D.previewMasksByStyle && D.previewMasksByStyle.length){
          var st0=D.previewMasksByStyle[0]; rec={src:st0.base, mask:st0.mask||st0.base}; }
        if(!rec || !rec.src) return Promise.resolve(null);
        var srcUrl=rec.src, maskUrl=rec.mask;
        var handle=((location.pathname.split('/products/')[1]||'tub').split('?')[0].split('/')[0])||'tub';
        var key=(handle+'-v'+((r.variant&&r.variant.id)||'x')+'-'+hex.replace(/[^0-9a-fA-F]/g,'')).toLowerCase();
        var gen=Promise.all([omnLoadImg(srcUrl), omnLoadImg(maskUrl)]).then(function(im){
          var base=im[0], mask=im[1];
          var W=base.naturalWidth||640, H=base.naturalHeight||640;
          var sc=Math.min(1, 720/Math.max(W,H)); W=Math.round(W*sc); H=Math.round(H*sc);
          var cv=document.createElement('canvas'); cv.width=W; cv.height=H; var ctx=cv.getContext('2d');
          ctx.fillStyle='#F5F0E6'; ctx.fillRect(0,0,W,H);              // cream ground (matches the gallery)
          ctx.drawImage(base,0,0,W,H);                                  // white tub on cream
          var off=document.createElement('canvas'); off.width=W; off.height=H; var octx=off.getContext('2d');
          octx.fillStyle=hex; octx.fillRect(0,0,W,H);
          octx.globalCompositeOperation='destination-in'; octx.drawImage(mask,0,0,W,H);  // hex shaped by the tub mask
          ctx.globalCompositeOperation='multiply'; ctx.drawImage(off,0,0,W,H);            // colour × white = colour, shading kept
          ctx.globalCompositeOperation='source-over';
          return new Promise(function(res){ cv.toBlob(function(b){ res(b); },'image/jpeg',0.86); });
        }).then(function(blob){
          if(!blob) return null;
          return fetch(OMN_RENDER_UPLOAD+'?key='+encodeURIComponent(key),{method:'POST',headers:{'Content-Type':'image/jpeg'},body:blob})
            .then(function(res){ return res.ok?res.json():null; }).then(function(j){ return (j&&j.url)||null; });
        });
        var timeout=new Promise(function(res){ setTimeout(function(){ res(null); },2500); });
        return Promise.race([gen, timeout]).catch(function(){ return null; });
      }catch(e){ return Promise.resolve(null); }
    }

    function paintNeutral(el){ el.style.background='repeating-linear-gradient(45deg,#eee,#eee 7px,#ddd 7px,#ddd 14px)'; }

    function refreshSummary(){
      var r=resolve();
      // remember the chosen colour for waste auto-match (tubs/trays/panels only)
      if(!WASTE && sel.mode==='palette' && sel.code && norm(sel.name)!=='white'){
        try{ localStorage.setItem('omn_last_colour', JSON.stringify({
          name:sel.name, code:sel.code, system:sel.system, hex:sel.hex,
          from:(D.productTitle||''), t:Date.now() })); }catch(_e){}
      }
      // Publish the chosen finish globally so the OmniSoak datasheet uses the real colour.
      try {
        var _fn = sel.mode==='palette' ? (sel.name||'White')
                : (sel.mode==='reference' ? (sel.ref||'Your reference')
                : (sel.note||'Bespoke match'));
        window.OmnitubFinish = { name:_fn, hex:(sel.mode==='palette' ? (sel.hex||'#FFFFFF') : '#FFFFFF') };
      } catch(e){}
      // trigger
      if(WASTE && sel.mode==='finish'){
        var _f=null; for(var _i=0;_i<FINISHES.length;_i++){ if(norm(FINISHES[_i].value)===norm(sel.name)){ _f=FINISHES[_i]; break; } }
        if(_f && _f.img){ trigSw.style.background='url('+_f.img+') center/cover'; }
        else { trigSw.style.background=finishTone(sel.name); }
      }
      else if(sel.mode==='palette'){ trigSw.style.background=sel.hex||'#FFFFFF'; } else { paintNeutral(trigSw); }
      var tcode = (WASTE && sel.mode==='finish') ? 'standard finish'
                : (sel.mode==='palette' && sel.code) ? sel.code
                : (sel.mode==='reference' ? (sel.ref||'') : '');
      trigVal.innerHTML = (r.isWhite?'White':escapeHtml(r.label)) +
        (tcode ? ' <span class="omn-cfg-trigger__meta">'+escapeHtml(tcode)+'</span>' : '');
      // summary chip
      if(WASTE && sel.mode==='finish'){
        var _ff=null; for(var _j=0;_j<FINISHES.length;_j++){ if(norm(FINISHES[_j].value)===norm(sel.name)){ _ff=FINISHES[_j]; break; } }
        if(_ff && _ff.img){ selChip.style.background='url('+_ff.img+') center/cover'; } else { selChip.style.background=finishTone(sel.name); }
      }
      else if(sel.mode==='palette'){ selChip.style.background=sel.hex||'#FFFFFF'; } else { paintNeutral(selChip); }
      selName.textContent = r.isWhite?'White':r.label;
      selMeta.textContent = (WASTE && sel.mode==='finish') ? 'Standard finish · ships from stock'
                          : WASTE ? ((sel.mode==='palette' && sel.code ? codeLabel()+' · ' : '')+'Omnitone — made to order, ~8 weeks')
                          : r.isWhite ? 'Ships without surcharge'
                          : (sel.mode==='palette' && sel.code ? codeLabel()+' · hand colour-matched, made to order'
                          : 'Hand colour-matched, made to order');
      priceEl.textContent = money(r.price);
      // Panels are made-to-measure: the foot shows the Size Builder's computed price
      // (dims + colour), never the variant default. The stored data-omps input is the
      // live contract; the Size Builder also rewrites this element on every recompute.
      if(D.panelMode){ try{ var ppi=document.querySelector('input[data-omps][name="properties[_omn_panel_price]"]');
        if(ppi && +ppi.value>0) priceEl.textContent=money(+ppi.value); }catch(e){} }
      addBtn.textContent = 'Add to basket';   /* #4 — clean button; price shows separately in the foot */
      // Wastes: the page's own price block + native Add follow the chosen finish (debounced).
      if(WASTE && r.drv && r.drv!==lastWasteDrv){
        lastWasteDrv=r.drv; clearTimeout(_wasteSyncT);
        var _wd=r.drv; _wasteSyncT=setTimeout(function(){ try{ syncNative(_wd); }catch(e){} }, 300);
      }
      paintPreview(r);
      // Keep the delivery date in step with the variant — but DEFERRED + debounced.
      // syncNative() drives the native 437-variant picker (price + delivery recompute),
      // which is heavy, so we run it ~350ms after the user stops picking and OFF the
      // click — the swatch tap/preview stays instant. Only fires when the selection
      // crosses white↔coloured (coloured = +10 working days; Sheer caveat baked in).
      if(typeof updateDeliv==='function' && r.isWhite!==lastWhiteForDate){
        lastWhiteForDate=r.isWhite;
        clearTimeout(_dateSyncT);
        _dateSyncT=setTimeout(function(){
          try{ syncNative(resolve().drv); }catch(e){}
          setTimeout(updateDeliv, 450); setTimeout(updateDeliv, 1000);
        }, 350);
      }
    }
    var lastWhiteForDate=true, _dateSyncT=null, lastWasteDrv=null, _wasteSyncT=null;   // overlay opens on White; date-sync debounce timer
    function escapeHtml(s){ return (s||'').replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }

    // ── live colour preview on the hero (P2.5) — recolour the featured photo to
    //    the chosen swatch via CSS blend (no canvas, no CORS, no per-product mask) ──
    function paintPreview(r){
      if(WASTE){
        r = r || resolve();
        if(previewFig) previewFig.classList.remove('is-tinted');
        if(typeof lbFig!=='undefined' && lbFig) lbFig.classList.remove('is-tinted');
        var src=null, capName='', capCap='';
        if(sel.mode==='finish'){
          var f=null; for(var i=0;i<FINISHES.length;i++){ if(norm(FINISHES[i].value)===norm(sel.name)){ f=FINISHES[i]; break; } }
          src=f&&f.img; capName=sel.name; capCap='Standard finish — ships from stock.';
          if(pvDot) pvDot.style.display='none';
        } else if(sel.mode==='palette'){
          var wv=wasteColourVariant();
          src=(wv&&wv.sku)?(D.r2Base+'/'+wv.sku+'.jpg'):null;
          capName=sel.name; capCap=(codeLabel()?codeLabel()+' · ':'')+'Omnitone — finished to order in your colour, around 8 weeks.';
          if(pvDot){ pvDot.style.background=sel.hex||'#FFFFFF'; pvDot.style.display='inline-block'; }
        } else {
          capName=(sel.mode==='reference')?(sel.ref||'Your reference'):'Bespoke match';
          capCap='Omnitone — hand-matched to order, around 8 weeks.';
          if(pvDot) pvDot.style.display='none';
        }
        if(src && previewImg && previewImg.getAttribute('src')!==src) previewImg.src=src;
        if(pvName) pvName.textContent=capName;
        if(pvCode) pvCode.textContent='';
        if(pvCap) pvCap.textContent=capCap;
        try{ document.dispatchEvent(new CustomEvent('omn:colour',{detail:{ sid:SID, active:false, hex:'', name:capName, code:'', mode:sel.mode }})); }catch(_e){}
        if(typeof syncLightbox==='function') syncLightbox();
        return;
      }
      if(!tintColor) return;                 // product has no featured image → no rail
      r = r || resolve();
      var hex = (sel.mode==='palette') ? (sel.hex||'#FFFFFF') : '';
      // PERF: only enable the blend/mask tint layer when a real colour is applied — keeps the
      // sticky preview a cheap plain image while browsing/white so the swatch grid scrolls smoothly.
      var tinted = !!hex && !r.isWhite;
      if(previewFig) previewFig.classList.toggle('is-tinted', tinted);
      if(lbFig) lbFig.classList.toggle('is-tinted', tinted);
      if(hex){
        tintColor.style.background=hex;          // white (#FFFFFF) → multiply/​color = no change = real photo
        tintMult.style.display='none';
        pvDot.style.background=hex; pvDot.style.display='inline-block';
        pvName.textContent = r.isWhite ? 'White' : (sel.name||'Your colour');
        if(pvCode) pvCode.textContent = r.isWhite ? '' : codeLabel();
        if(pvCap) pvCap.textContent = r.isWhite
          ? 'Standard white — shown as photographed. Screen colours are indicative.'
          : ((codeLabel() ? codeLabel()+' · ' : '') + 'indicative preview — every finish is hand-matched on the bench');
      } else {
        // reference / bespoke without a swatch hex → show the real photo + intent
        tintColor.style.background='#FFFFFF'; tintMult.style.display='none';
        pvDot.style.display='none';
        pvName.textContent = (sel.mode==='reference') ? (sel.ref || 'Your reference') : 'Bespoke match';
        if(pvCode) pvCode.textContent='';
        if(pvCap) pvCap.textContent = 'We’ll hand-match your '+(sel.mode==='reference'?'reference':'colour')+' precisely on the bench.';
      }
      // ── Image journey (Phase 1): broadcast the chosen finish so the product-page
      //    gallery recolours its hero (and every angle) underneath the builder, ready
      //    the moment the customer closes the build. Palette colours only — white /
      //    bespoke / reference fall back to the real photograph (active:false).
      try{
        document.dispatchEvent(new CustomEvent('omn:colour',{detail:{
          sid: SID,
          active: !!hex && !r.isWhite,
          hex: hex || '',
          name: (pvName ? pvName.textContent : ''),
          code: (pvCode ? pvCode.textContent : ''),
          mode: sel.mode
        }}));
      }catch(_e){}
      if(REALCOLOUR) cutoutPaint();                 // real render overrides the tint when a cutout exists
      if(typeof syncLightbox==='function') syncLightbox();
    }

    // ── per-style preview mask (PANELS) — swap base image + mask to match the
    //    selected Panel Style so the recolour always paints the right shape.
    //    No-op for trays (D.previewMasksByStyle is null). ──
    function currentPanelStyle(){
      var vp=document.querySelector('variant-picker'); if(!vp||!D.styleOption) return null;
      var s=vp.querySelector('.option-selector[data-option="'+esc(D.styleOption)+'"]'); if(!s) return null;
      var ci=s.querySelector('input.js-option:checked, input[type="radio"]:checked');
      if(ci){ var lab=ci.id?document.querySelector('label[for="'+ci.id+'"]'):null; return ((ci.value||(lab&&lab.textContent)||'')+'').trim(); }
      var ds=s.querySelector('.custom-select__option[aria-selected="true"]'); if(ds) return ((ds.dataset.value||ds.textContent||'')+'').trim();
      var ns=s.querySelector('select'); if(ns&&ns.options[ns.selectedIndex]) return ns.options[ns.selectedIndex].text.trim();
      return null;
    }
    function applyStyleMask(){
      if(!D.previewMasksByStyle||!previewFig||!previewImg) return;
      var st=currentPanelStyle(), rec=null;
      D.previewMasksByStyle.forEach(function(x){ if(norm(x.style)===norm(st)) rec=x; });
      if(!rec) rec=D.previewMasksByStyle[0];
      if(!rec||!rec.mask||!rec.base) return;
      if(previewImg.getAttribute('src')!==rec.base) previewImg.src=rec.base;
      previewFig.style.setProperty('--omn-mask', "url('"+rec.mask+"')");
      previewFig.classList.add('is-masked');
    }

    // ── multi-angle VIEW pagination (TUBS) — step the camera angles via the
    //    bottom-right pill. Swaps base+mask; the CSS tint re-masks + re-applies.
    //    Each render PNG's own alpha is the mask, so src doubles as base + mask. ──
    var PR = D.previewRenders || null;
    // Drop the near-edge-on "low" hero angle from the browsable rotation — it renders as a
    // flat sliver and reads as broken. Keep every other angle. Fall back to the full set if
    // filtering somehow empties it.
    if(PR && PR.length){ var _pf = PR.filter(function(r){ return !/low/i.test((r&&r.label)||''); }); if(_pf.length) PR = _pf; }
    var feetOn = false, curView = 0;
    var viewLabel=$('omn-cfg-view-label'), viewnav=$('omn-cfg-viewnav'), feetWrap=$('omn-cfg-feet');
    // ── REAL-COLOUR cutout helpers ──
    function cutAngles(){ return (feetOn && CUT && CUT.feetAngles && CUT.feetAngles.length) ? CUT.feetAngles : (CUT ? CUT.angles : []); }
    function curCutSku(){
      if(!REALCOLOUR || sel.mode!=='palette') return null;        // reference/bespoke → keep the tint fallback
      if(norm(sel.name)==='white') return WHITE_SKU || null;
      var r=resolve(); return (r.variant && r.variant.sku) || null;
    }
    function cutoutPaint(){                                        // → true if it took over the image
      var sku=curCutSku(); if(!sku) return false;
      var L=cutAngles(); if(!L.length) return false;
      var a=L[((curView % L.length)+L.length)%L.length], url=CUT.base+'/'+a.key+'/'+sku+'.png';
      if(previewImg){
        if(previewImg.getAttribute('src')!==url){
          // Preload-then-swap: decode the new cutout off-screen, then assign — no stale-frame
          // flash on the live preview. onerror keeps the existing on-floor .jpg fallback.
          var im=new Image();
          im.onload=function(){ previewImg.onerror=function(){ previewImg.onerror=null; previewImg.src=D.r2Base+'/'+sku+'.jpg'; }; previewImg.src=im.src; };
          im.onerror=function(){ previewImg.onerror=null; previewImg.src=D.r2Base+'/'+sku+'.jpg'; }; // safety: on-floor render always exists
          im.src=url;
        }
      }
      if(previewFig){ previewFig.classList.remove('is-tinted'); previewFig.classList.remove('is-masked'); }
      if(viewLabel) viewLabel.textContent=a.label||('View '+(curView+1));
      if(typeof lbImg!=='undefined' && lbImg && lbImg.getAttribute('src')!==url) lbImg.src=url;
      if(typeof lbFig!=='undefined' && lbFig){ lbFig.classList.remove('is-tinted'); lbFig.classList.remove('is-masked'); }
      if(typeof lbLabel!=='undefined' && lbLabel) lbLabel.textContent=a.label||'';
      return true;
    }
    // With feet ON, only the angles that HAVE a feet render are available (feet read
    // from the exterior only). effSrc/effMask pick the feet variant when toggled on.
    function vlist(){ return (feetOn && PR) ? PR.filter(function(r){return r.feetSrc;}) : (PR||[]); }
    function effSrc(r){ return (feetOn && r && r.feetSrc) ? r.feetSrc : (r&&r.src); }
    function effMask(r){ return (feetOn && r && r.feetMask) ? r.feetMask : (r && (r.mask||r.src)); }
    function effShadow(r){ return (feetOn && r && r.feetShadowSrc) ? r.feetShadowSrc : (r && r.shadowSrc); }
    function setView(i){
      if(REALCOLOUR && curCutSku()){                              // real-colour: step the cutout angles
        var LC=cutAngles(); if(LC.length){ curView=((i % LC.length)+LC.length)%LC.length; cutoutPaint(); return; }
      }
      var L=vlist(); if(!L.length || !previewImg || !previewFig) return;
      curView = ((i % L.length) + L.length) % L.length;          // wrap both ways
      var r = L[curView], src=effSrc(r), mk=effMask(r), sh=effShadow(r);
      if(previewImg.getAttribute('src')!==src) previewImg.src=src;
      previewFig.style.setProperty('--omn-mask', "url('"+mk+"')");
      if(sh) previewFig.style.setProperty('--omn-shadow', "url('"+sh+"')");
      previewFig.classList.add('is-masked');
      var lbl = r.label || ('View '+(curView+1));
      if(viewLabel) viewLabel.textContent = lbl;
      if(lbLabel) lbLabel.textContent = lbl;
      syncLightbox();
    }
    if(viewnav){
      viewnav.addEventListener('click', function(e){
        var b=e.target.closest('.omn-cfg__viewnav-btn'); if(!b) return;
        setView(curView + (parseInt(b.getAttribute('data-dir'),10)||1));
      });
    }
    // Feet toggle — the builder + the expanded view share ONE state. Hidden when
    // this product has no feet renders.
    var hasFeet = REALCOLOUR ? !!(CUT && CUT.feetAngles && CUT.feetAngles.length)
                             : !!(PR && PR.some(function(r){return r.feetSrc;}));
    var lbFeetWrap=$('omn-cfg-lbfeet');
    function syncFeetUI(){
      [feetWrap, lbFeetWrap].forEach(function(w){ if(!w) return;
        w.querySelectorAll('.omn-cfg__feet-opt').forEach(function(x){
          x.setAttribute('aria-pressed', (x.getAttribute('data-feet')==='1')===feetOn ? 'true':'false'); }); });
    }
    function setFeet(on){ feetOn=!!on; curView=0; syncFeetUI(); setView(0); }
    [feetWrap, lbFeetWrap].forEach(function(w){ if(!w) return;
      if(!hasFeet){ w.style.display='none'; return; }
      w.addEventListener('click', function(e){ var b=e.target.closest('.omn-cfg__feet-opt'); if(b) setFeet(b.getAttribute('data-feet')==='1'); });
    });
    // ── Background: neutral presets + "Any colour" (the full RAL/BS library) ──
    // (the shadow adapts via multiply, so any backdrop works). bgPickMode flips the main
    // swatch grid to set the BACKDROP instead of the tub finish.
    var bgTrigger=$('omn-cfg-bgtrigger'), bgDot=$('omn-cfg-bgdot'), bgBanner=$('omn-cfg-bgbanner'), bgDoneBtn=$('omn-cfg-bgdone');
    function setBgColour(col){
      if(previewFig) previewFig.style.setProperty('--omn-pvbg', col);
      if(lbFig) lbFig.style.setProperty('--omn-pvbg', col);
      if(bgDot) bgDot.style.background=col;
    }
    function setBgPick(on){
      bgPickMode=on;
      if(bgTrigger) bgTrigger.setAttribute('aria-pressed', on?'true':'false');
      if(bgBanner) bgBanner.hidden=!on;
      if(on) applyMethod('browse','all');   // ensure the swatch grid is in view
    }
    if(bgTrigger) bgTrigger.addEventListener('click', function(){ setBgPick(!bgPickMode); });
    if(bgDoneBtn) bgDoneBtn.addEventListener('click', function(){ setBgPick(false); });
    // Preload every render (base + mask + feet variants) so view/feet swaps are instant.
    var _preloaded=false;
    function _warm(u){ if(!u) return; var im=new Image(); try{ im.decoding='async'; }catch(e){} im.src=u; }
    function preloadRenders(){
      if(_preloaded) return; _preloaded=true;
      if(PR){ PR.forEach(function(r){ ['src','mask','shadowSrc','feetSrc','feetMask','feetShadowSrc'].forEach(function(k){
        if(r[k]) _warm(r[k]); }); }); }
      // Tray real-colour path: warm the CUTOUT URLs too so colour/angle steps don't round-trip.
      // Warm the selected colour across its angle set (+ the white baseline that the default view uses).
      if(REALCOLOUR && CUT && CUT.base){
        var skus=[]; var cs=curCutSku(); if(cs) skus.push(cs);
        if(WHITE_SKU && skus.indexOf(WHITE_SKU)<0) skus.push(WHITE_SKU);
        var angs=(CUT.angles||[]).concat(CUT.feetAngles||[]);
        skus.forEach(function(sku){ angs.forEach(function(a){ if(a&&a.key) _warm(CUT.base+'/'+a.key+'/'+sku+'.png'); }); });
      }
    }

    // ── Expand lightbox — a big copy of the figure mirroring the current view + colour ──
    var expandBtn=$('omn-cfg-expand'), lightbox=$('omn-cfg-lightbox'),
        lbFig=$('omn-cfg-lb-fig'), lbImg=$('omn-cfg-lb-img'), lbTint=$('omn-cfg-lb-tint'), lbClose=$('omn-cfg-lb-close'),
        lbLabel=$('omn-cfg-lb-label'), lbnav=$('omn-cfg-lbnav');
    function syncLightbox(){
      if(!lbFig) return;
      if(REALCOLOUR && cutoutPaint()){ if(lbTint) lbTint.style.background='#FFFFFF'; return; }   // real render → no tint in the expand view
      var L=vlist(), r = L[curView] || null;
      if(r){ var s=effSrc(r); if(lbImg && lbImg.getAttribute('src')!==s) lbImg.src=s;
             lbFig.style.setProperty('--omn-mask', "url('"+effMask(r)+"')");
             var sh=effShadow(r); if(sh) lbFig.style.setProperty('--omn-shadow', "url('"+sh+"')"); }
      if(lbTint) lbTint.style.background = (sel.mode==='palette' ? (sel.hex||'#FFFFFF') : '#FFFFFF');
    }
    function openLightbox(){ if(!lightbox) return; syncLightbox(); lightbox.dataset.open='true'; }
    function closeLightbox(){ if(lightbox) lightbox.dataset.open='false'; }
    if(expandBtn) expandBtn.addEventListener('click', openLightbox);
    if(lbClose) lbClose.addEventListener('click', closeLightbox);
    if(lbnav){ lbnav.addEventListener('click', function(e){ var b=e.target.closest('.omn-cfg__lb-navbtn'); if(b) setView(curView + (parseInt(b.getAttribute('data-dir'),10)||1)); }); }
    if(lightbox) lightbox.addEventListener('click', function(e){ if(e.target===lightbox) closeLightbox(); });
    // Mobile info toggle — reveal the assurance line (hidden on mobile to save space).
    var infoBtn=$('omn-cfg-info'), assureEl=$('omn-cfg-assure');
    if(infoBtn && assureEl){ infoBtn.addEventListener('click', function(){ var op=assureEl.classList.toggle('is-open'); infoBtn.setAttribute('aria-expanded', op?'true':'false'); }); }

    // ── native picker driving (idempotent) ──
    function nativePicker(){ return document.querySelector('variant-picker'); }
    function nativeForm(){ return document.querySelector('.js-product-form'); }
    function syncNative(value){
      if(!value) return;
      var vp=nativePicker(); if(!vp) return;
      var name=D.colourOption;
      var s=(name&&vp.querySelector('.option-selector[data-option="'+esc(name)+'"]'))||vp.querySelector('.option-selector');
      if(!s) return;
      try{
        if(s.dataset.selectorType==='dropdown'){
          var cs=s.querySelector('custom-select'); if(!cs) return;
          var cur=cs.querySelector('.custom-select__option[aria-selected="true"]');
          if(cur && norm(cur.dataset.value)===norm(value)) return;
          var opt=cs.querySelector('.custom-select__option[data-value="'+esc(value)+'"]');
          if(opt && typeof cs.selectOption==='function') cs.selectOption(opt);
        } else {
          var inp=s.querySelector('input[value="'+esc(value)+'"]');
          if(inp && !inp.checked){ inp.checked=true; inp.dispatchEvent(new CustomEvent('change',{bubbles:true,cancelable:false,detail:{noFocus:true}})); }
        }
      }catch(e){}
    }
    function injectProps(form, props){
      if(!form) return;
      form.querySelectorAll('input[data-omn-cfg-prop]').forEach(function(n){ n.remove(); });
      Object.keys(props).forEach(function(k){
        if(!props[k]) return;
        var i=document.createElement('input'); i.type='hidden'; i.name='properties['+k+']'; i.value=props[k];
        i.setAttribute('data-omn-cfg-prop',''); form.appendChild(i);
      });
    }

    // build id (browser-side random is fine here)
    var BUILD_ID = 'b'+Date.now().toString(36)+Math.floor(Math.random()*1e6).toString(36);

    // Full-screen "Adding to your basket…" cover — masks the brief /cart navigation so the
    // product page never flashes through. Created once, appended to <body>; gone on /cart load.
    function showAdding(){
      try{ var c=document.getElementById('omn-cfg-adding-'+SID);
        if(!c){ c=document.createElement('div'); c.id='omn-cfg-adding-'+SID; c.className='omn-cfg__adding';
          c.innerHTML='<div class="omn-cfg__adding-inner"><span class="omn-cfg__adding-spin" aria-hidden="true"></span><p>Adding to your basket…</p></div>';
          document.body.appendChild(c); }
        c.classList.add('is-on');
      }catch(e){}
    }
    // ── Bundle cross-sell — "add a shower tray / a bath to your order?" ──────────
    // After the FINAL successful add-to-basket, the fullscreen cover becomes a simple
    // question: on tubs, offer a tray; on trays, offer a tub (D.xsell from the data
    // island; null for panels/wastes = no offer). Capped at ONE hop per session
    // (sessionStorage), so tub→tray or tray→tub — never an endless loop. Yes → the
    // build is already in the basket; route to the studio's range picker mid-bundle.
    // No → straight to the basket (original behaviour).
    function xsellEligible(){
      try{ return !!D.xsell && !sessionStorage.getItem('omn_xsell'); }catch(e){ return false; }
    }
    function xsellEvent(n){ try{ if(window.gtag) gtag('event', n, {target:D.xsell||''}); }catch(e){} }
    // ── Staff draft-order builder ────────────────────────────────────────────
    // Turns the finished studio build into a Shopify DRAFT ORDER (phone/WhatsApp
    // sales): same line items + properties the basket would get, plus the free
    // Feet line (the Function that zeroes feet doesn't run on drafts — the
    // Worker zeroes it per-line and applies the sitewide promo explicitly).
    function draftFeetLine(items){
      try {
        var F=window.OMN_FEET; if(!F || !F.enabled || !F.variant) return null;
        var pid=(window.meta && window.meta.product && window.meta.product.id) ? String(window.meta.product.id) : null;
        var n=pid ? (F.map[pid]||0) : 0; if(!n) return null;
        return { id:F.variant, quantity:n, properties:{
          '_omn_feet_for': String(items[0].id)+':draft',
          '_omn_build': (items[0].properties||{})['_omn_build']||'' } };
      } catch(e){ return null; }
    }
    function draftWorkerBase(){
      try { var w=document.querySelector('.omw'); return ((w&&w.dataset.evidence)||'').replace(/\/sign\/?$/,''); }
      catch(e){ return ''; }
    }
    function showDraftOrder(items, key){
      var c=document.getElementById('omn-cfg-adding-'+SID);
      if(!c) return Promise.resolve({__draft:true});
      var feet=draftFeetLine(items); if(feet) items=items.concat([feet]);
      c.classList.add('is-on');
      c.innerHTML='<div class="omn-cfg__adding-inner omn-cfg__xsell omn-cfg__draft">'
        +'<p class="omn-cfg__xsell-added">Staff — draft order builder</p>'
        +'<h3 class="omn-cfg__xsell-q">Create a draft order</h3>'
        +'<p class="omn-cfg__xsell-sub">This build goes onto a Shopify draft order for the customer — nothing is added to your own basket.</p>'
        +'<div class="omn-cfg__draft-form">'
        +'<input type="email" id="omn-do-email" placeholder="Customer email (required)" autocomplete="off">'
        +'<div class="omn-cfg__draft-row"><input type="text" id="omn-do-first" placeholder="First name"><input type="text" id="omn-do-last" placeholder="Last name"></div>'
        +'<textarea id="omn-do-note" rows="2" placeholder="Note for the order (optional)"></textarea>'
        +'<p class="omn-cfg__draft-err" id="omn-do-err" hidden></p>'
        +'</div>'
        +'<button type="button" class="omn-cfg__xsell-yes" id="omn-do-go">Create draft order →</button>'
        +'<button type="button" class="omn-cfg__xsell-no" id="omn-do-cart">Add to my basket instead</button>'
        +'</div>';
      return new Promise(function(resolve){
        function err(m){ var e=document.getElementById('omn-do-err'); if(e){ e.textContent=m; e.hidden=false; } }
        document.getElementById('omn-do-cart').addEventListener('click', function(){
          fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({items:items.filter(function(it){ return !(it.properties||{})['_omn_feet_for']; })})})
            .then(function(r){ if(!r.ok) throw new Error('add'); window.location.href='/cart'; })
            .catch(function(){ err('Could not add to basket — try again.'); });
        });
        document.getElementById('omn-do-go').addEventListener('click', function(){
          var email=(document.getElementById('omn-do-email').value||'').trim();
          if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ err('Enter the customer\u2019s email address.'); return; }
          var go=document.getElementById('omn-do-go'); go.disabled=true; go.textContent='Creating\u2026';
          fetch(draftWorkerBase()+'/draft-order',{method:'POST',
            headers:{'content-type':'application/json','x-omn-staff':key},
            body:JSON.stringify({
              customer:{ email:email,
                firstName:(document.getElementById('omn-do-first').value||'').trim(),
                lastName:(document.getElementById('omn-do-last').value||'').trim() },
              note:(document.getElementById('omn-do-note').value||'').trim(),
              items:items.map(function(it){ return { variantId:it.id, quantity:it.quantity, properties:it.properties||{} }; })
            })})
            .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); })
            .then(function(x){
              if(!x.ok || !x.j.ok) throw new Error((x.j&&x.j.error)||'draft failed');
              var signBlock='';
              if(x.j.signUrl){
                signBlock='<div class="omn-cfg__draft-form" style="margin-top:1.2rem">'
                  +'<p class="omn-cfg__xsell-sub" style="margin:0"><b>Bespoke cutting on this build</b> — the customer signs this link before you invoice. You\u2019ll get an email the moment they do.</p>'
                  +'<div class="omn-cfg__draft-row" style="grid-template-columns:1fr auto"><input type="text" readonly id="omn-do-signurl" value="'+escapeHtml(x.j.signUrl)+'"><button type="button" class="omn-cfg__xsell-no" style="margin:0;width:auto" id="omn-do-copy">Copy</button></div>'
                  +'<button type="button" class="omn-cfg__xsell-no" style="margin:0" id="omn-do-emaillink">Email the link to '+escapeHtml(email)+' \u2192</button>'
                  +'</div>';
              }
              c.innerHTML='<div class="omn-cfg__adding-inner omn-cfg__xsell omn-cfg__draft">'
                +'<p class="omn-cfg__xsell-added">\u2713 Draft order '+escapeHtml(x.j.name)+' created</p>'
                +'<h3 class="omn-cfg__xsell-q">The build is on the draft order</h3>'
                +'<p class="omn-cfg__xsell-sub">Add the delivery address and shipping in admin, then send the invoice or take payment. Your own basket is untouched.</p>'
                +signBlock
                +'<a class="omn-cfg__xsell-yes" style="text-decoration:none;text-align:center" href="'+escapeHtml(x.j.adminUrl)+'" target="_blank" rel="noopener">Open '+escapeHtml(x.j.name)+' in Shopify admin \u2192</a>'
                +'<button type="button" class="omn-cfg__xsell-no" id="omn-do-done">Done — back to the studio</button>'
                +'</div>';
              document.getElementById('omn-do-done').addEventListener('click', function(){ c.classList.remove('is-on'); });
              var el=document.getElementById('omn-do-emaillink');
              if(el){ el.addEventListener('click', function(){
                // deliberate confirmation step — nothing emails the customer until this click
                el.disabled=true; el.textContent='Sending\u2026';
                var tok=(x.j.signUrl||'').split('/').pop();
                fetch(draftWorkerBase()+'/countersign-send',{method:'POST',
                  headers:{'content-type':'application/json','x-omn-staff':key},
                  body:JSON.stringify({token:tok})})
                  .then(function(r){ return r.json().then(function(j){ return {ok:r.ok&&j.ok, j:j}; }); })
                  .then(function(y){
                    if(!y.ok) throw new Error((y.j&&y.j.error)||'failed');
                    el.textContent='\u2713 Emailed to '+(y.j.to||email);
                  })
                  .catch(function(e){ el.disabled=false; el.textContent='Email failed — try again ('+e.message+')'; });
              }); }
              var cp=document.getElementById('omn-do-copy');
              if(cp){ cp.addEventListener('click', function(){
                var inp=document.getElementById('omn-do-signurl'); inp.select();
                var done=function(){ cp.textContent='Copied \u2713'; setTimeout(function(){ cp.textContent='Copy'; },2000); };
                if(navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(inp.value).then(done, function(){ document.execCommand('copy'); done(); }); }
                else { document.execCommand('copy'); done(); }
              }); }
              resolve({__draft:true, name:x.j.name});
            })
            .catch(function(e){ go.disabled=false; go.textContent='Create draft order \u2192'; err('Could not create the draft order: '+e.message); });
        });
      });
    }

    // In-studio cross-sell picker — the "Yes" answer stays INSIDE the studio experience
    // (operator feedback 3 Jul: don't bounce back to the website page mid-flow). The cover
    // becomes a size grid fetched from the live collection; picking a size goes straight
    // into that product's own studio (?omnistudio=open). Full studio page kept as a quiet
    // fallback link.
    var XSELL_TUB_RANGES=[['deep-bathtubs','The Deep Soaking range'],['the-sheer-collection','The Sheer Collection'],['deep-seated-baths','Seated Baths'],['multi-person-tubs','Multi-Person Tubs']];
    function xsellMoney(v){ v=parseFloat(v)||0; return '£'+(v%1===0?v.toFixed(0):v.toFixed(2)); }
    function xsellCards(prods){
      return prods.map(function(p){
        var t=(p.title||'').split(/\s+[–—|]\s+/)[0];
        var src=(p.images&&p.images[0]&&p.images[0].src)||'';
        var img=src?(src+(src.indexOf('?')>-1?'&':'?')+'width=360'):'';
        var min=null; (p.variants||[]).forEach(function(v){ var pr=parseFloat(v.price); if(pr && (min===null||pr<min)) min=pr; });
        return '<a class="omn-cfg__xsell-card" href="/products/'+p.handle+'?omnistudio=open">'
          +(img?('<img src="'+img+'" alt="" loading="lazy">'):'')
          +'<span class="t">'+escapeHtml(t)+'</span>'
          +(min?('<span class="p">from '+xsellMoney(min)+'</span>'):'')+'</a>';
      }).join('');
    }
    function xsellPickFrame(c, heading, bodyHtml){
      var pickedBuilt = D.xsell==='tub' ? 'shower tray' : 'bath';
      c.innerHTML='<div class="omn-cfg__adding-inner omn-cfg__xsell omn-cfg__xsell--pick">'
        +'<p class="omn-cfg__xsell-added">✓ Your '+pickedBuilt+' is in your basket — adding this is optional</p>'
        +'<h3 class="omn-cfg__xsell-q">'+heading+'</h3>'
        +bodyHtml
        +'<a class="omn-cfg__xsell-alt" href="/pages/the-drawing-room?bundle='+D.xsell+'">Browse the full studio page instead →</a>'
        +'</div>';
    }
    function xsellGrid(c, heading, collection, excludeSheer){
      xsellPickFrame(c, heading, '<div class="omn-cfg__xsell-grid"><p class="omn-cfg__xsell-sub">Loading sizes…</p></div>');
      fetch('/collections/'+collection+'/products.json?limit=50').then(function(r){ return r.json(); }).then(function(j){
        var prods=(j.products||[]).filter(function(p){ return !excludeSheer || (p.handle||'').indexOf('sheer')===-1; });
        var g=c.querySelector('.omn-cfg__xsell-grid');
        if(g) g.innerHTML=prods.length?xsellCards(prods):'<p class="omn-cfg__xsell-sub">Nothing here right now — try the full studio page below.</p>';
      }).catch(function(){ var g=c.querySelector('.omn-cfg__xsell-grid'); if(g) g.innerHTML='<p class="omn-cfg__xsell-sub">Could not load sizes — use the full studio page below.</p>'; });
    }
    function showXsellPicker(c){
      if(D.xsell==='tray'){ xsellGrid(c, 'Pick your shower tray size', 'omnitub-british-made-shower-trays', false); return; }
      xsellPickFrame(c, 'Which bath are you drawn to?', '<div class="omn-cfg__xsell-grid omn-cfg__xsell-grid--ranges">'
        +XSELL_TUB_RANGES.map(function(r){ return '<button type="button" class="omn-cfg__xsell-card" data-xr="'+r[0]+'" data-xt="'+r[1]+'"><span class="t">'+r[1]+'</span><span class="p">Choose →</span></button>'; }).join('')+'</div>');
      c.addEventListener('click', function h(e){ var b=e.target.closest('[data-xr]'); if(!b) return;
        c.removeEventListener('click', h);
        xsellGrid(c, 'Pick your bath size', b.getAttribute('data-xr'), b.getAttribute('data-xr')==='deep-bathtubs'); });
    }
    function showXsell(){
      try{
        var c=document.getElementById('omn-cfg-adding-'+SID); if(!c) return false;
        var offerTub = D.xsell==='tub';   // they just built a tray → offer a bath
        // Copy rule (operator, 4 Jul): customers must never wonder whether the other
        // product is REQUIRED. Say outright that it isn't before offering it.
        var built  = offerTub ? 'shower tray' : 'bath';
        var offered= offerTub ? 'bath' : 'shower tray';
        c.innerHTML='<div class="omn-cfg__adding-inner omn-cfg__xsell">'
          +'<p class="omn-cfg__xsell-added">✓ Your '+built+' is in your basket — it\u2019s complete on its own</p>'
          +'<h3 class="omn-cfg__xsell-q">Did you know we manufacture '+(offerTub?'Baths':'Shower Trays')+'?</h3>'
          +'<p class="omn-cfg__xsell-sub">If you\u2019re also fitting a '+(offerTub?'bath':'shower')+', we handmake matching '+offered+'s in the same colours — and everything arrives together. Entirely optional. Would you like a look?</p>'
          +'<button type="button" class="omn-cfg__xsell-yes">'+(offerTub?'Yes please — show me the baths →':'Yes please — show me the shower trays →')+'</button>'
          +'<button type="button" class="omn-cfg__xsell-no">No thanks — just the '+built+'. Take me to my basket</button>'
          +'</div>';
        c.classList.add('is-on');
        c.querySelector('.omn-cfg__xsell-yes').addEventListener('click', function(){
          try{ sessionStorage.setItem('omn_xsell','1'); }catch(e){}
          xsellEvent('xsell_accept');
          showXsellPicker(c);   // stay in the studio — pick the size right here
        });
        c.querySelector('.omn-cfg__xsell-no').addEventListener('click', function(){
          xsellEvent('xsell_decline');
          window.location.href='/cart';
        });
        xsellEvent('xsell_offer');
        return true;
      }catch(e){ return false; }
    }
    function addToCart(){
      var r=resolve(); if(!r.variant){ return; }
      if(sel.mode==='reference' && !(refInput.value||'').trim()){ refInput.focus(); return; }
      if(sel.mode==='bespoke' && !(bespokeInput.value||'').trim()){ bespokeInput.focus(); return; }
      // Panels are made-to-measure: NEVER add without dimensions, whatever path got us
      // here — close the overlay and send the customer to the Size Builder instead.
      // (L-shaped also needs its return length.)
      if(D.panelMode){
        var _len=document.querySelector('input[data-omps][name="properties[_omn_panel_len]"]');
        var _kind=document.querySelector('input[data-omps][name="properties[_omn_panel_kind]"]');
        var _ret=document.querySelector('input[data-omps][name="properties[_omn_panel_ret]"]');
        var _needRet=_kind && /^l-/.test(_kind.value||'');
        if(!_len || !(+_len.value>0) || (_needRet && (!_ret || !(+_ret.value>0)))){
          try{ closeOverlay(); }catch(e){}
          var _sb=document.querySelector('.omps');
          if(_sb){ var _err=_sb.querySelector('.omps__err'); if(_err) _err.hidden=false;
            _sb.scrollIntoView({behavior:'smooth',block:'center'});
            var _li=_sb.querySelector('.omps__in'); if(_li) setTimeout(function(){ _li.focus(); },450); }
          return;
        }
      }
      addBtn.disabled=true; addBtn.textContent='Adding…'; showAdding();
      var props=Object.assign({}, r.props); props['_omn_build']=BUILD_ID;
      // Carry any made-to-measure panel dimensions onto the line. The Size Builder
      // stashes them as hidden input[data-omps][name="properties[...]"] inside its own
      // <section> (panel pages have no product <form>), so scan document-wide for those
      // AND any native-form property inputs (with-tub flow). Last value wins per key.
      try{
        var _inputs=[];
        var _f=nativeForm(); if(_f){ _f.querySelectorAll('input[name^="properties["]').forEach(function(i){ _inputs.push(i); }); }
        document.querySelectorAll('input[data-omps][name^="properties["]').forEach(function(i){ _inputs.push(i); });
        _inputs.forEach(function(inp){ var mm=inp.name.match(/^properties\[(.+)\]$/); if(mm && inp.value!=='' && inp.value!=null) props[mm[1]]=inp.value; });
      }catch(e){}
      // keep buy box consistent for either add path
      syncNative(r.drv); injectProps(nativeForm(), r.props);
      colourImageProp(r).then(function(imgUrl){
        if(imgUrl){ props['_colour_image']=imgUrl; props['_colour_hex']=sel.hex; }
        return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:[{id:r.variant.id,quantity:1,properties:props}]})});
      })
        .then(function(res){ if(!res.ok) throw new Error('add'); return res.json(); })
        .then(function(){
          if(xsellEligible() && showXsell()) return;   // bundle question first — Yes routes to the other studio, No → /cart
          if(document.querySelector('cart-drawer')){
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
            setTimeout(function(){ document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); },60);
            closeOverlay();
          } else { window.location.href='/cart'; }
        })
        .catch(function(){ var c=document.getElementById('omn-cfg-adding-'+SID); if(c) c.classList.remove('is-on'); addBtn.disabled=false; refreshSummary(); selMeta.textContent='Could not add — please try the buy box, or call 01934 750005.'; });
    }

    // ── RAL licence §2(2) swatch helpers ────────────────────────────────────────
    //   RAL chips paint from the sprite IMAGE (c.si → OmnSwatch.styleFor); BS 4800 is
    //   Omnitub's own data and keeps its hex. swHex()/datasetHex() SAMPLE the sprite
    //   cell for a concrete tint value (allowed — using the value to render; never
    //   re-published as data). Sampling needs the sprite decoded; on a very fast first
    //   tap it can be null, so callers async-resolve + repaint.
    function swFill(c){
      return (c && c.system==='RAL' && c.si!=null && window.OmnSwatch)
        ? OmnSwatch.styleFor(c.si) : ('background:'+((c&&c.hex)||'#FFFFFF'));
    }
    function swHex(c){
      if(!c) return null;
      if(c.system==='RAL' && c.si!=null && window.OmnSwatch) return OmnSwatch.hexSync(c.si);
      return c.hex||null;
    }
    function datasetHex(sw){
      if(sw.dataset.hex) return sw.dataset.hex;
      var si=(sw.dataset.si!=='' && sw.dataset.si!=null) ? +sw.dataset.si : null;
      if(si!=null && window.OmnSwatch){ var h=OmnSwatch.hexSync(si); if(h) return h; }
      return '';
    }
    // ── render swatches ──
    function swatchEl(c, pinned){
      var b=document.createElement('button'); b.type='button'; b.className='omn-cfg__sw'+(pinned?' omn-cfg__sw--pinned':'');
      var on=(sel.mode==='palette' && norm(sel.name)===norm(c.name) && norm(sel.code)===norm(c.code));
      b.setAttribute('aria-pressed', on?'true':'false');
      b.dataset.family=c.family; b.dataset.code=c.code; b.dataset.name=c.name; b.dataset.system=c.system;
      b.dataset.hex=(c.hex||''); if(c.si!=null) b.dataset.si=c.si;
      b.title=c.name+' · '+c.system+' '+c.code+(pinned?' · standard finish':'');
      b.innerHTML='<span class="omn-cfg__sw-fill" style="'+swFill(c)+';">'+(pinned?'<span class="omn-cfg__sw-tag">Standard</span>':'')+'</span>'+
        '<span class="omn-cfg__sw-meta"><span class="omn-cfg__sw-name">'+escapeHtml(c.name)+'</span>'+
        '<span class="omn-cfg__sw-code"><span class="omn-cfg__badge '+(c.system==='RAL'?'ral':'')+'">'+(c.system==='BS4800'?'BS 4800':c.system)+'</span>'+
        '<span class="omn-cfg__sw-codeval">'+escapeHtml(c.code)+'</span></span></span>';
      return b;   /* selection handled by delegation on the grid */
    }

    function matchEl(){
      var b=document.createElement('button'); b.type='button';
      b.className='omn-cfg__sw omn-cfg__sw--pinned omn-cfg__sw--match';
      var on=(sel.mode==='palette' && norm(sel.name)===norm(MATCH.name) && norm(sel.code)===norm(MATCH.code));
      b.setAttribute('aria-pressed', on?'true':'false');
      b.dataset.family=''; b.dataset.code=MATCH.code; b.dataset.name=MATCH.name;
      b.dataset.system=MATCH.system; b.dataset.hex=MATCH.hex;
      b.title='Match your '+(MATCH.from||'tub')+' — '+MATCH.name+' '+MATCH.code;
      b.innerHTML='<span class="omn-cfg__sw-fill" style="background:'+MATCH.hex+';"><span class="omn-cfg__sw-tag omn-cfg__sw-tag--match">Your colour</span></span>'+
        '<span class="omn-cfg__sw-meta"><span class="omn-cfg__sw-name">'+escapeHtml(MATCH.name)+'</span>'+
        '<span class="omn-cfg__sw-code"><span class="omn-cfg__badge '+(MATCH.system==='RAL'?'ral':'')+'">'+(MATCH.system==='BS4800'?'BS 4800':MATCH.system)+'</span>'+
        '<span class="omn-cfg__sw-codeval">'+escapeHtml(MATCH.code)+' · matched to your choice</span></span></span>';
      return b;
    }
    function finishEl(f){
      var b=document.createElement('button'); b.type='button';
      b.className='omn-cfg__sw omn-cfg__sw--pinned omn-cfg__sw--finish';
      var on=(sel.mode==='finish'&&norm(sel.name)===norm(f.value));
      b.setAttribute('aria-pressed', on?'true':'false');
      b.dataset.finish=f.value;
      b.title=f.value+' · standard finish — ships from stock';
      b.innerHTML='<span class="omn-cfg__sw-fill" style="'+(f.img?('background-image:url('+f.img+');background-size:cover;background-position:center;'):('background:'+finishTone(f.value)+';'))+'"><span class="omn-cfg__sw-tag">Standard</span></span>'+
        '<span class="omn-cfg__sw-meta"><span class="omn-cfg__sw-name">'+escapeHtml(f.value)+'</span>'+
        '<span class="omn-cfg__sw-code"><span class="omn-cfg__sw-codeval">Ships from stock</span></span></span>';
      return b;
    }
    var activeFamily='All', sourceFilter='all';
    function inSource(c){ return sourceFilter==='all' || c.system===sourceFilter; }
    // The standard Omnitub finish — BS 4800 00 E 55 White. We pin its swatch to the
    // top of the browse grid so it's ALWAYS the first thing the customer sees and can
    // always return to, regardless of the search query or family/method filter.
    function isWhiteSwatch(c){ return c && norm(c.system)==='bs4800' && norm(c.code)==='00 e 55'; }
    function whiteSwatch(){
      for(var i=0;i<COLOURS.length;i++){ if(isWhiteSwatch(COLOURS[i])) return COLOURS[i]; }
      return { name:'White', code:'00 E 55', system:'BS4800', hex:'#F1F2EA', family:'Whites & Neutrals' };
    }
    function renderGrid(){
      grid.innerHTML='';
      var q=norm(activeQuery); searchCorrected='';
      var list;
      if(q){
        var toks=canon(activeQuery).split(' ').filter(Boolean);
        list = COLOURS.filter(function(c){ return inSource(c) && matchTokens(c,toks); });
        if(!list.length){                         // nothing → fuzzy "did you mean"
          var ctoks=toks.map(correctToken);
          if(ctoks.join(' ')!==toks.join(' ')){
            list = COLOURS.filter(function(c){ return inSource(c) && matchTokens(c,ctoks); });
            if(list.length) searchCorrected=ctoks.join(' ');
          }
        }
      } else {
        list = COLOURS.filter(function(c){ return inSource(c) && (activeFamily==='All' || c.family===activeFamily); });
      }
      var frag=document.createDocumentFragment();
      if(WASTE){
        // your remembered tub/tray colour first (one-tap match), then the
        // standard metal finishes — the fixed defaults
        if(MATCH) frag.appendChild(matchEl());
        FINISHES.forEach(function(f){ frag.appendChild(finishEl(f)); });
      } else {
        // Always pin standard White first; de-dupe it from the natural list so it never doubles up.
        var pinned=whiteSwatch();
        if(pinned) frag.appendChild(swatchEl(pinned, true));
      }
      list.filter(function(c){ return !isWhiteSwatch(c); }).forEach(function(c){ frag.appendChild(swatchEl(c)); });
      grid.appendChild(frag);
      syncSearchUi(q, list.length);               // count reflects real matches; pinned White is extra
      if(!list.length){ var p=document.createElement('p'); p.className='omn-cfg__empty';
        p.textContent = q ? ('No other colours match “'+activeQuery.trim()+'”. Try a different name, or use “Enter a reference” for any paint code.')
                          : 'No other colours in this view — try All colours.';
        grid.appendChild(p); }
    }
    // reflect search state: live count + a "did you mean" line when we auto-corrected
    function syncSearchUi(q, n){
      if(browsePane) browsePane.classList.toggle('is-searching', !!q);
      if(qCount){
        if(q){ qCount.hidden=false;
          if(searchCorrected){
            qCount.innerHTML='Showing <em>'+n+'</em> '+(n===1?'result':'results')+' for “'+escapeHtml(searchCorrected)+'” — did you mean that? (you typed “'+escapeHtml(activeQuery.trim())+'”)';
          } else {
            qCount.innerHTML='<em>'+n+'</em> '+(n===1?'colour':'colours')+' match “'+escapeHtml(activeQuery.trim())+'”';
          }
        } else { qCount.hidden=true; qCount.textContent=''; }
      }
    }
    function renderFamilies(){
      famWrap.innerHTML='';
      var counts={}; COLOURS.filter(inSource).forEach(function(c){ counts[c.family]=(counts[c.family]||0)+1; });
      var all=['All'].concat(FAMILIES.filter(function(f){return counts[f];}));
      all.forEach(function(f){
        var b=document.createElement('button'); b.type='button'; b.className='omn-cfg__fam'; b.dataset.fam=f;
        b.setAttribute('aria-pressed', f===activeFamily?'true':'false');
        b.innerHTML=escapeHtml(f)+(f==='All'?'':'<span class="n">'+(counts[f]||0)+'</span>');
        b.addEventListener('click', function(){ applyFamily(f); });
        famWrap.appendChild(b);
      });
      renderFamilySelect(counts, all);
    }
    // mirror the family pills into the mobile <select>
    function renderFamilySelect(counts, all){
      if(!famGroup) return;
      if(!counts){ counts={}; COLOURS.filter(inSource).forEach(function(c){ counts[c.family]=(counts[c.family]||0)+1; }); }
      if(!all){ all=['All'].concat(FAMILIES.filter(function(f){return counts[f];})); }
      famGroup.innerHTML='';
      all.forEach(function(f){
        if(f==='All') return;                                  // "All colours" (top option) already covers it
        var o=document.createElement('option'); o.value='fam|'+f;
        o.textContent=f+' ('+(counts[f]||0)+')';
        if(f===activeFamily) o.selected=true;
        famGroup.appendChild(o);
      });
    }
    // single family-state setter shared by pills + the combined dropdown
    // When the merged filter dropdown moves INTO a browse/family view, drop any stale
    // reference/bespoke selection so the foot, preview and price reflect what's on screen
    // (the bug: picking "Enter a reference"/"Bespoke" then switching to RAL/family left the
    //  foot stuck on "your bespoke colour" at the coloured price until a swatch was clicked).
    // A real palette pick is preserved — only non-palette modes reset to White.
    function clearStaleSel(){
      if(sel.mode!=='palette'){
        sel.mode='palette'; sel.name='White'; sel.code='00 E 55'; sel.system='BS4800'; sel.hex='#FFFFFF';
        overlay.querySelectorAll('.omn-cfg__sw[aria-pressed="true"]').forEach(function(s){ s.setAttribute('aria-pressed','false'); });
      }
    }
    function applyFamily(f){
      clearStaleSel();
      activeFamily=f; sourceFilter='all';                      // a family view spans all sources
      if(activeQuery){ activeQuery=''; if(qInput) qInput.value=''; }   // choosing a family supersedes a search
      famWrap.querySelectorAll('.omn-cfg__fam').forEach(function(x){ x.setAttribute('aria-pressed', x.dataset.fam===f?'true':'false'); });
      // make the browse pane active (in case we were on reference/bespoke)
      panes.forEach(function(p){ p.dataset.active = (p.dataset.pane==='browse')?'true':'false'; });
      renderFamilies();
      if(methodSel){ methodSel.value = (f==='All') ? 'browse|all' : ('fam|'+f); }
      renderGrid(); refreshSummary();
    }
    function renderSearch(q){
      searchGrid.innerHTML=''; q=norm(q);
      if(!q) return;
      var list=COLOURS.filter(function(c){ return norm(c.name).indexOf(q)>-1 || norm(c.code).indexOf(q)>-1 || norm(c.system).indexOf(q)>-1; }).slice(0,60);
      var frag=document.createDocumentFragment();
      list.forEach(function(c){ frag.appendChild(swatchEl(c)); });
      searchGrid.appendChild(frag);
    }

    // ── method: tabs (desktop) + dropdown (mobile) drive one shared state ──
    function applyMethod(pane, source){
      pane = pane || 'browse';
      var want = (pane==='browse') ? (source || 'all') : '';
      tabs.forEach(function(x){ x.setAttribute('aria-selected', (x.dataset.pane===pane && (x.dataset.source||'')===want) ? 'true':'false'); });
      panes.forEach(function(p){ p.dataset.active = (p.dataset.pane===pane)?'true':'false'; });
      if(methodSel) methodSel.value = pane+'|'+want;
      if(pane==='browse'){
        clearStaleSel();                                  // drop stale reference/bespoke when returning to browse
        sourceFilter = want || 'all'; activeFamily='All';
        renderFamilies(); renderGrid();
        if(familySel) familySel.disabled=false;
      } else if(pane==='reference'){ sel.mode='reference'; sel.ref=(refInput.value||'').trim(); if(familySel) familySel.disabled=true; }
      else if(pane==='bespoke'){ sel.mode='bespoke'; sel.note=(bespokeInput.value||'').trim(); if(familySel) familySel.disabled=true; }
      refreshSummary();
    }
    tabs.forEach(function(t){ t.addEventListener('click', function(){ applyMethod(t.dataset.pane, t.dataset.source); }); });
    if(methodSel) methodSel.addEventListener('change', function(){
      var v=methodSel.value;
      if(v.indexOf('fam|')===0){ applyFamily(v.slice(4)); }      // family option
      else { var p=v.split('|'); applyMethod(p[0], p[1]); }       // method/reference/bespoke option
    });
    // swatch selection via delegation — robust across grid re-renders (fixes the intermittent "stuck on white")
    function onSwatchClick(e){
      var sw=e.target.closest('.omn-cfg__sw'); if(!sw) return;
      if(sw.dataset.finish){
        sel.mode='finish'; sel.name=sw.dataset.finish; sel.code=''; sel.system=''; sel.hex='';
        grid.querySelectorAll('.omn-cfg__sw').forEach(function(x){ x.setAttribute('aria-pressed', x===sw?'true':'false'); });
        refreshSummary(); paintPreview();
        return;
      }
      if(bgPickMode){ setBgColour(datasetHex(sw)); return; }   // background-pick mode → set the backdrop
      overlay.querySelectorAll('.omn-cfg__sw[aria-pressed="true"]').forEach(function(s){ s.setAttribute('aria-pressed','false'); });
      sw.setAttribute('aria-pressed','true');
      sel.mode='palette'; sel.name=sw.dataset.name; sel.code=sw.dataset.code; sel.system=sw.dataset.system; sel.hex=datasetHex(sw);
      refreshSummary();
      // sprite still decoding on a very fast tap → resolve the RAL tint async + repaint
      if(!sel.hex && sw.dataset.si!=='' && sw.dataset.si!=null && window.OmnSwatch){
        var _si=+sw.dataset.si, _code=sw.dataset.code;
        OmnSwatch.hex(_si, function(hx){ if(hx && sel.mode==='palette' && norm(sel.code)===norm(_code)){ sel.hex=hx; refreshSummary(); paintPreview(); } });
      }
    }
    grid.addEventListener('click', onSwatchClick);
    searchGrid.addEventListener('click', onSwatchClick);
    // "Back to white" button retired 2026-06-09 — the pinned standard White swatch (always first
    // in the grid) is now the way back to white; tapping it runs the same selection path above.
    // ── live search across the browse grid — collapsible glass (desktop + mobile) ──
    function applyQuery(v){
      activeQuery=v||'';
      if(activeQuery.trim() && (!browsePane || browsePane.dataset.active!=='true')){
        applyMethod('browse', sourceFilter);   // searching always shows browse results
      }
      renderGrid();
    }
    function setSearchOpen(open){
      if(searchWrap) searchWrap.hidden=!open;
      qToggles.forEach(function(t){ t.setAttribute('aria-expanded', open?'true':'false'); });
      if(open && qInput){ try{ qInput.focus({preventScroll:true}); }catch(e){ qInput.focus(); } }
    }
    // Collapsing the search KEEPS the typed query + filtered results (operator: closing
    // search shouldn't dump you back to all colours). Reset to all = delete the text, or
    // pick a Method/Colour family. clearSearch() is the explicit "back to everything".
    function collapseSearch(){ setSearchOpen(false); }
    function clearSearch(){ if(qInput) qInput.value=''; applyQuery(''); }
    function toggleSearch(){ if(searchWrap && searchWrap.hidden) setSearchOpen(true); else collapseSearch(); }
    qToggles.forEach(function(t){ t.addEventListener('click', toggleSearch); });
    if(qInput){
      qInput.addEventListener('input', function(){ applyQuery(qInput.value); });
      qInput.addEventListener('keydown', function(e){ if(e.key==='Escape'){ e.stopPropagation(); collapseSearch(); } });
    }
    // The in-field × clears back to all colours; the magnifying-glass toggle just hides the field (keeps results).
    if(qClose){ qClose.addEventListener('click', clearSearch); }
    var qMin=$('omn-cfg-qmin'); if(qMin){ qMin.addEventListener('click', collapseSearch); }   // minimise: hide the bar, keep the results
    // fade the mobile "slide" hint once the lane has been scrolled
    grid.addEventListener('scroll', function(){
      if(grid.scrollLeft > 8){ var p=grid.closest('.omn-cfg__panel-pane'); if(p) p.classList.add('is-scrolled'); }
    }, {passive:true});
    if(refInput) refInput.addEventListener('input', function(){ sel.mode='reference'; sel.ref=(refInput.value||'').trim(); renderSearch(refInput.value); refreshSummary(); });
    if(bespokeInput) bespokeInput.addEventListener('input', function(){ sel.mode='bespoke'; sel.note=(bespokeInput.value||'').trim(); refreshSummary(); });
    addBtn.addEventListener('click', addToCart);

    // ── Seamless stepped builder: goStep + foot wiring (no-op unless SEAMLESS) ──
    //   Step ① colour ↔ step ② waste, inside the SAME overlay. "Continue →" advances to
    //   the waste step (reusing the waste module's open() via the hidden towaste button);
    //   "Add the tub on its own" adds just the tub. goStep is exposed on the api so the
    //   waste module's "← Back" can return to colour.
    function goStep(step){
      if(!SEAMLESS) return;
      overlay.dataset.step = step;
      var p=overlay.querySelector('.omn-cfg__panel'); if(p) p.scrollTop=0;
      if(step==='waste'){ var tw=document.getElementById('omn-cfg-towaste-'+SID); if(tw) tw.click(); }
    }
    var contBtn=document.getElementById('omn-cfg-continue-'+SID);
    if(contBtn){
      if(D.panelMode || D.wasteMode){
        // Panels AND wastes are the end of the line — no step-2. Choose → Add to basket → done.
        contBtn.textContent='Add to basket →';
        contBtn.addEventListener('click', addToCart);
      } else {
        contBtn.addEventListener('click', function(){ goStep('waste'); });
      }
    }
    // Wastes + panels: the filled "Add to basket →" is THE add; hide the duplicate plain one.
    if(D.wasteMode && addBtn){ addBtn.hidden=true; addBtn.style.display='none'; }
    var addonlyBtn=document.getElementById('omn-cfg-addonly-'+SID);
    if(addonlyBtn){
      if(D.panelMode || D.wasteMode){ addonlyBtn.hidden=true; }   // meaningless for a panel or a waste
      else { addonlyBtn.addEventListener('click', addToCart); }
    }

    // ── open / close + focus trap ──
    var lastFocus=null;
    // Mirror the product page's delivery widget into the builder (read its computed date from the DOM).
    function updateDeliv(){
      var pills=overlay.querySelectorAll('.omn-cfg__deliv'); if(!pills.length) return;   // header (desktop) + foot (mobile)
      var dEl=document.querySelector('[data-delivery-date]');
      var date=dEl?(dEl.textContent||'').trim():'';
      var eb=document.querySelector('.omn-delivery-sticky__eyebrow');
      var lab=(eb&&(eb.textContent||'').trim())||'Free UK delivery as early as';
      var ok = !!date && !/calculat|working out/i.test(date) && date!=='—';
      overlay.querySelectorAll('.omn-cfg__deliv-lab').forEach(function(e){ e.textContent=lab; });
      overlay.querySelectorAll('.omn-cfg__deliv-date').forEach(function(e){ e.textContent=date; });
      pills.forEach(function(p){ p.hidden=!ok; });
    }
    function openOverlay(){
      // Certified 3D baths: the legacy overlay is retired — every open path
      // (trigger click, ?omnistudio=open deep-link, OMN_CFG openColour API)
      // goes to the live OmniStudio builder instead. Flag set in the section
      // liquid via omn-bath3d-flag (operator ruling 29 Jul 2026).
      if(trigger && trigger.dataset && trigger.dataset.omnGo){ location.href=trigger.dataset.omnGo; return; }
      lastFocus=document.activeElement;
      applyStyleMask();   // match the preview's base+mask to the selected Panel Style (panels)
      // Warm the angle/feet/shadow render cache AFTER the open paints — eagerly loading ~48
      // large PNGs on open was the slow first launch. Deferred to idle so the open is instant;
      // the cache is ready by the time the user navigates views/feet/expand.
      if('requestIdleCallback' in window){ requestIdleCallback(preloadRenders, {timeout:2500}); }
      else { setTimeout(preloadRenders, 1200); }
      overlay.dataset.open='true'; document.documentElement.style.overflow='hidden';
      if(SEAMLESS){ overlay.classList.add('omn-seam'); overlay.dataset.step='colour'; }   // always open on step ① (colour)
      updateDeliv(); setTimeout(updateDeliv, 500);   // widget may compute the date a moment after
      var c=overlay.querySelector('.omn-cfg__close'); if(c) c.focus();
    }
    // keep the panel preview's shape in sync if the Panel Style is changed (native picker / variant change)
    document.addEventListener('on:variant:change', applyStyleMask);
    document.addEventListener('change', function(e){
      if(e.target && e.target.closest && e.target.closest('variant-picker')) setTimeout(applyStyleMask, 30);
    });
    function reassertTakeover(){
      var vp=nativePicker(); if(!vp) return;
      var name=D.colourOption;
      var s=(name&&vp.querySelector('.option-selector[data-option="'+esc(name)+'"]'))||vp.querySelector('.option-selector');
      if(!s) return;
      if(trigger.parentNode!==s.parentNode){ s.parentNode.insertBefore(trigger, s); }
      s.setAttribute('data-omn-hidden','true');
      document.documentElement.classList.add('omn-cfg-took-over');
      refreshSummary();   // re-render the trigger label after any variant re-render (retains selection)
    }
    // Persistent guard: Shopify re-renders the variant picker on any variant change (e.g. after the
    // studio's "Done" selects the colour), which UNDOES the takeover — the native dropdown reappears
    // and the trigger is lost (can't reopen the studio). This observer re-asserts the takeover the
    // instant it's undone, so the launcher always stays put. Self-loop-safe: only acts when the
    // takeover is actually broken, and disconnects while it repairs.
    var guardMo=null;
    function startGuard(){
      if(guardMo) return;
      var root=document.querySelector('.product-info')||nativeForm()||nativePicker();
      if(!root) return;
      guardMo=new MutationObserver(function(){
        var vp=nativePicker(); if(!vp) return;
        var name=D.colourOption;
        var s=(name&&vp.querySelector('.option-selector[data-option="'+esc(name)+'"]'))||vp.querySelector('.option-selector');
        if(!s) return;
        if(s.getAttribute('data-omn-hidden')!=='true' || trigger.parentNode!==s.parentNode){
          guardMo.disconnect();
          reassertTakeover();
          try{ guardMo.observe(root,{childList:true,subtree:true,attributes:true}); }catch(e){}
        }
      });
      try{ guardMo.observe(root,{childList:true,subtree:true,attributes:true}); }catch(e){ guardMo=null; }
    }
    function applyToBuyBox(){
      var r=resolve();
      syncNative(r.drv);                 // buy-box price + selected variant track the studio
      injectProps(nativeForm(), r.props); // so the native Add-to-Cart also carries the colour
      reassertTakeover();
      setTimeout(reassertTakeover, 450);  // belt-and-braces after any async variant re-render
    }
    function closeOverlay(){
      overlay.dataset.open='false'; document.documentElement.style.overflow='';
      // Reset the waste module reparented inside the overlay. Esc / scrim / overlay-X all route
      // here but DON'T run the waste module's own close(), so a leftover .omw[data-open="true"]
      // would survive — making the studio re-open onto the half-rendered waste step instead of
      // the colour step (reads as a frozen/broken page). Clearing it leaves a clean state.
      var _w=overlay.querySelector('.omw'); if(_w){ _w.dataset.open='false'; }
      applyToBuyBox();
      if(lastFocus && lastFocus.focus) lastFocus.focus();
    }
    overlay.addEventListener('click', function(e){ if(e.target.hasAttribute('data-omn-close')) closeOverlay(); });
    document.addEventListener('keydown', function(e){
      if(overlay.dataset.open!=='true') return;
      if(lightbox && lightbox.dataset.open==='true'){ if(e.key==='Escape') closeLightbox(); return; }
      if(e.key==='Escape') closeOverlay();
      if(e.key==='Tab'){
        var f=overlay.querySelectorAll('button:not([disabled]), input, textarea, [tabindex]:not([tabindex="-1"])');
        f=Array.prototype.filter.call(f, function(el){ return el.offsetParent!==null; });
        if(!f.length) return;
        var first=f[0], last=f[f.length-1];
        if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
        else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
      }
    });
    trigger.addEventListener('click', openOverlay);

    // ── Deep-link auto-open ──────────────────────────────────────────────────
    // The OmniStudio finder (/pages/the-drawing-room) sends shoppers straight here with
    // ?omnistudio=open so the studio launches on arrival — "select your product
    // first, then the studio takes over". Waits until hoist() un-hides the trigger
    // (so the takeover is in place) before opening; gives up after a few seconds.
    // ── Staff mode (draft-order builder) ────────────────────────────────────
    // Visit any studio page once with ?omn_staff=<key> to mark this device as
    // staff. The final add step then offers "Create draft order" — the build
    // lands on a Shopify draft order (phone/WhatsApp sales) instead of the
    // basket. The key is validated server-side by the evidence Worker.
    try {
      var _skm = location.search.match(/[?&]omn_staff=([^&]+)/);
      if (_skm) {
        localStorage.setItem('omn_staff', decodeURIComponent(_skm[1]));
        var _q = location.search.replace(/[?&]omn_staff=[^&]*/, '').replace(/^&/, '?');
        history.replaceState(null, '', location.pathname + _q + location.hash);
      }
    } catch (e) {}

    if(/[?&]omnistudio=open\b/.test(location.search)){
      // Cover the product page IMMEDIATELY — arriving shoppers (finder, cross-sell
      // size picker) must land in the studio, never on a raw PDP. If the takeover
      // is slow to initialise (mobile connections), they wait behind this cover,
      // not in front of the product page. Operator bug report 4 Jul: the old 6s
      // give-up left slow loads dumped on the product page.
      var aoCover=document.createElement('div');
      aoCover.style.cssText='position:fixed;inset:0;z-index:2147483000;background:#F7F4ED;display:flex;align-items:center;justify-content:center;font-family:inherit;';
      aoCover.innerHTML='<div style="text-align:center;color:#2C3E2D;"><div style="width:34px;height:34px;margin:0 auto 14px;border:3px solid rgba(184,155,94,.35);border-top-color:#B89B5E;border-radius:50%;animation:omnAoSpin .8s linear infinite;"></div><div style="font-size:16px;letter-spacing:.04em;">Opening your studio\u2026</div></div><style>@keyframes omnAoSpin{to{transform:rotate(360deg)}}</style>';
      (document.body||document.documentElement).appendChild(aoCover);
      var aoRemove=function(){ try{ if(aoCover.parentNode) aoCover.parentNode.removeChild(aoCover); }catch(e){} };
      var autoOpened=false;
      var tryAutoOpen=function(){
        if(autoOpened) return true;
        if(trigger.hidden) return false;
        try{ openOverlay(); autoOpened=true; aoRemove(); }catch(e){}   // failed open ≠ done — retry on the next tick
        return autoOpened;
      };
      if(!tryAutoOpen()){
        var aoTimer=setInterval(function(){ if(tryAutoOpen()) clearInterval(aoTimer); }, 120);
        setTimeout(function(){ clearInterval(aoTimer); aoRemove(); }, 20000);   // graceful give-up: show the page
      }
    }

    // ── Order-builder hook ──────────────────────────────────────────────────
    // Lets the ISOLATED waste module (separate <script>, so its bugs can't break
    // this colour flow) add the tub + the chosen waste VARIANT in one /cart/add
    // call — both are real variants, so both decrement stock and the cart-level
    // discount Function applies.
    window.OMN_CFG = window.OMN_CFG || {};
    window.OMN_CFG[SID] = {
      hasTub: function(){ try { return !!resolve().variant; } catch(e){ return false; } },
      // Short display title for tallies/summaries: first dash-segment — but ranges like
      // "Omnitub Sheer – 1200 × 700 Deep Soaking Tub – 600mm Depth" lead with the NAME,
      // so if the first segment has no size, pull in the segment that does. The customer
      // must always see the dimensions of what they're building.
      shortTitle: function(){ var parts=(D.productTitle||'').split(/\s*[\u2013\u2014]\s*/), t=(parts[0]||'').trim();
        if(!/\d{3,4}\s*[x\u00d7]/i.test(t)){ for(var i=1;i<parts.length;i++){ if(/\d{3,4}\s*[x\u00d7]\s*\d{3,4}/i.test(parts[i])){ t+=' \u2014 '+parts[i].trim(); break; } } }
        return t; },
      selection: function(){ try { var r=resolve(); return { colour: r.isWhite?'White':(r.label||sel.name||'your colour'), title: this.shortTitle() }; } catch(e){ return {colour:'',title:''}; } },
      openColour: function(){ try { openOverlay(); } catch(e){} },
      closeColour: function(){ try { closeOverlay(); } catch(e){} },
      seamless: SEAMLESS,
      // Expose the chosen tub colour so the panel step can auto-match it. `value` is the
      // Color option value used on the tub (matches the panels' option values 1:1);
      // `exact` = a real palette swatch (vs a bespoke/reference fallback to Custom Colour).
      colourSel: function(){ try { var r=resolve(); var matched = sel.mode==='palette' && (r.isWhite || !!namedColourVariant() || !!byValue[norm(sel.name)]);
        return { name:(r.isWhite?'White':(sel.name||r.label||'your colour')), value:r.drv, isWhite:!!r.isWhite,
                 exact:!!matched, props:Object.assign({}, r.props||{}), hex:sel.hex }; } catch(e){ return null; } },
      goStep: function(s){ try { goStep(s); } catch(e){} },
      // Running-order data for the waste step's tally (so the customer always sees the tub,
      // the price, and the delivery date as they add a waste).
      summary: function(){ try { var r=resolve(); var dt=document.getElementById('omn-cfg-deliv-date-'+SID);
        return { title:this.shortTitle(),
                 colour:(r.isWhite?'White':(r.label||sel.name||'your colour')),
                 priceNum:r.price, price:money(r.price),
                 deliv:(dt?((dt.textContent||'').trim()):'') }; } catch(e){ return null; } },
      // ── Drilling step plumbing (overflow / tap holes) ───────────────────────────
      //   The Overflow + Taps steps push their chargeable service line-items into
      //   drillItems, and stamp the TUB line with tubExtraProps (so the cart/order read
      //   the tub itself as bespoke, drilled-to-order, non-returnable). addTubPlusItems
      //   is the single cart-add choke point (waste-direct AND panel hand-off both route
      //   through it exactly once), so merging here means every path includes the drilling
      //   without changing call sites.
      drillItems: [],
      tubExtraProps: {},
      addTubPlusItems: function(extra){
        var r=resolve(); if(!r.variant) return Promise.reject(new Error('no tub variant'));
        showAdding();
        var props=Object.assign({}, r.props); props['_omn_build']=BUILD_ID;
        try { Object.assign(props, (window.OMN_CFG[SID]||{}).tubExtraProps||{}); } catch(e){}
        try { syncNative(r.drv); injectProps(nativeForm(), r.props); } catch(e){}
        return colourImageProp(r).then(function(imgUrl){
          if(imgUrl){ props['_colour_image']=imgUrl; props['_colour_hex']=sel.hex; }
          var drill=[]; try { drill=(window.OMN_CFG[SID]||{}).drillItems||[]; } catch(e){}
          var items=[{id:r.variant.id,quantity:1,properties:props}].concat(extra||[]).concat(drill);
          // Stamp EVERY line with the build id so the whole group (tub + waste + services +
          // panel) is identifiable later — powers the cart 'Edit in studio' replace-on-re-add.
          items.forEach(function(it){ it.properties=Object.assign({}, it.properties||{}, {'_omn_build':BUILD_ID}); });
          var staffKey=null; try{ staffKey=localStorage.getItem('omn_staff'); }catch(e){}
          if(staffKey){ return { __draft: true, items: items, key: staffKey }; }
          return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({items:items})});
        })
          .then(function(res){
            if(res && res.__draft){ return showDraftOrder(res.items, res.key); }
            if(!res.ok) throw new Error('add'); return res.json(); })
          .then(function(j){ if(j && j.__draft) return j; return Promise.resolve(j); })
          .then(function(j){
            if(j && j.__draft) return j;   // draft-order path: basket untouched, stop here
            // Edit-from-basket: the new build is in — now remove the OLD line group it replaces
            // (keys stashed by the studio's ?omn_edit boot). Failure = duplicate lines, never a loss.
            var rm=null; try{ rm=JSON.parse(sessionStorage.getItem('omn_edit_remove')||'null'); }catch(e){}
            if(rm && rm.length){
              try{ sessionStorage.removeItem('omn_edit_remove'); }catch(e){}
              var updates={}; rm.forEach(function(k){ updates[k]=0; });
              return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
                body:JSON.stringify({updates:updates})}).then(function(){ return j; }, function(){ return j; });
            }
            return j;
          })
          .then(function(j){
            if(j && j.__draft) return j;   // draft-order path: no xsell, no cart redirect
            if(xsellEligible() && showXsell()) return j;   // bundle question — Yes routes to the other studio, No → /cart
            if(document.querySelector('cart-drawer')){
              document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
              setTimeout(function(){ document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); },60);
              try { closeOverlay(); } catch(e){}
            } else { window.location.href='/cart'; }
            return j;
          });
      }
    };

    // ── hoist trigger into the buy box + hide native colour control ──
    function hoist(){
      var vp=nativePicker();
      var moved=false;
      if(vp){
        var name=D.colourOption;
        var s=(name&&vp.querySelector('.option-selector[data-option="'+esc(name)+'"]'))||vp.querySelector('.option-selector');
        if(s){
          s.parentNode.insertBefore(trigger, s);
          s.setAttribute('data-omn-hidden','true');
          document.documentElement.classList.add('omn-cfg-took-over');
          moved=true;
          // initialise from current native selection
          var cur=s.querySelector('.custom-select__option[aria-selected="true"], input:checked');
          var v=cur?(cur.dataset.value||cur.value):'White';
          if(WASTE){
            // Wastes (5 Oct 2026): the native picker sits on variant #1 (Brushed Brass) by default.
            // Adopting it as a PALETTE pick is what labelled Brass "Omnitone — made to order, ~8
            // weeks" with a blank chip. Only an explicit ?variant= deep link is adopted, and a
            // standard finish stays a finish; otherwise the sheet keeps its "from" finish.
            if(URL_VARIANT && v){
              var _fin=null; for(var _k=0;_k<FINISHES.length;_k++){ if(norm(FINISHES[_k].value)===norm(v)){ _fin=FINISHES[_k]; break; } }
              if(_fin){ sel.mode='finish'; sel.name=_fin.value; sel.code=''; sel.system=''; sel.hex=''; }
              else if(byValue[norm(v)] && norm(v).indexOf('custom')<0){ sel.mode='palette'; sel.name=v; sel.code=''; sel.system=''; sel.hex='#FFFFFF'; }
            }
          }
          else if(v && norm(v)!=='white'){ sel.mode='palette'; sel.name=v; sel.code=''; sel.system=''; sel.hex='#FFFFFF'; }
        }
      }
      if(!moved){
        // fallback: drop the trigger at the top of the product form so it's still usable
        var form=nativeForm();
        if(form){ form.insertBefore(trigger, form.firstChild); }
      }
      trigger.hidden=false;
      refreshSummary();
      startGuard();   // keep the takeover alive across native variant re-renders (fixes lost launcher after "Done")
    }

    // move overlay to <body> so it's never trapped inside the product form
    if(overlay.parentNode!==document.body) document.body.appendChild(overlay);

    // ── load colour library ──
    fetch(D.assetUrl).then(function(r){ return r.json(); }).then(function(lib){
      COLOURS=lib.colours||[]; FAMILIES=(lib._meta&&lib._meta.families)||[];
      if(loading) loading.remove();
      renderFamilies(); renderGrid();
      // PRESELECT from ?colour=<ral-slug> (or the sessionStorage echo assets/omn-colour-param.js
      // writes as 'omn_colour::<handle>') — the ad-landing PDP hands the customer's clicked RAL
      // straight into this overlay, exactly like the dedicated studio (omnitub-studio
      // src/classic.js colour preselect). Matches on the SAME slug the PDP builds
      // (slugify(code)); applies via the normal chip-tap path (sel + renderGrid +
      // refreshSummary) so it paints the preview, reprices, and stays fully changeable.
      // No-op when the param is absent or unknown, and never overrides a colour the
      // customer (or a restored build) already picked — a real pick always carries a
      // code, whereas hoist()'s init-from-native-variant leaves code blank (on gated
      // PDPs omn-colour-param has already switched the native picker to the Custom
      // Colour carrier BEFORE the library loads, so sel.name is the carrier label,
      // not White — the blank code is what identifies it as not-a-real-pick).
      // Wastes keep their own flow.
      try {
        if (!WASTE && sel.mode === 'palette' && (norm(sel.name) === 'white' || !sel.code)) {
          var _slugc = function (x) { return String(x).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); };
          var _pc = null;
          try { _pc = new URLSearchParams(location.search).get('colour'); } catch (_e0) {}
          if (!_pc) {
            var _h = ((location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0]) || '';
            if (_h) { try { _pc = sessionStorage.getItem('omn_colour::' + _h); } catch (_e1) {} }
          }
          if (_pc) {
            var _t = _slugc(_pc), _hit = null;
            for (var _i = 0; _i < COLOURS.length; _i++) { if (_slugc(COLOURS[_i].code) === _t) { _hit = COLOURS[_i]; break; } }
            if (_hit) {
              sel.mode = 'palette'; sel.name = _hit.name; sel.code = _hit.code; sel.system = _hit.system; sel.hex = swHex(_hit) || '';
              renderGrid();          // re-render marks the matching swatch pressed (swatchEl reads sel)
              refreshSummary();      // price + foot + hero preview — the same path as a chip tap
              if (!sel.hex && _hit.si != null && window.OmnSwatch) {   // sprite not yet decoded → resolve + repaint
                OmnSwatch.hex(_hit.si, function (hx) { if (hx && norm(sel.code) === norm(_hit.code)) { sel.hex = hx; refreshSummary(); paintPreview(); } });
              }
            }
          }
        }
      } catch (_e) {}
    }).catch(function(){ if(loading) loading.textContent='Colour library unavailable — use “Enter a reference” or call us.'; });

    // Hoist ASAP — the instant the colour option-selector exists in the DOM (often before it
    // paints) — so the native 100-swatch picker never flashes before the trigger replaces it.
    // Was DOMContentLoaded (too late → visible flash). Progressive + safe: JS off ⇒ nothing
    // hidden, native picker shows (buyable). If the selector never appears, a 3s fallback still
    // drops the trigger into the form so the studio is always reachable.
    (function bootHoist(){
      function findSel(){
        var vp=nativePicker(); if(!vp) return null;
        var name=D.colourOption;
        return (name && vp.querySelector('.option-selector[data-option="'+esc(name)+'"]')) || vp.querySelector('.option-selector');
      }
      if(findSel()){ hoist(); return; }
      var done=false;
      function go(){ if(done) return; done=true; try{mo.disconnect();}catch(e){} hoist(); }
      var mo;
      try{
        mo=new MutationObserver(function(){ if(!done && findSel()) go(); });
        mo.observe(document.documentElement, {childList:true, subtree:true});
      }catch(e){
        if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', hoist); } else { hoist(); }
        return;
      }
      setTimeout(go, 3000);              // belt-and-braces: trigger always appears
    })();

    } // end __bootRest — everything above runs once variant data is ready

    // P0 defer dispatch: non-deferred products have inline D.variants and run immediately;
    // deferred (437-colour) products lazy-fetch the variant index from the minimal
    // /products/<handle>?view=cfgjson template (renders ONLY that JSON) before booting.
    var __needCfg = D && (D.cfgDeferred || (D.variantsDeferred && !D.variants));
    if (__needCfg) {
      var __cfgU = '/products/' + encodeURIComponent(D.cfgHandle || '') + '?view=cfgjson';
      fetch(__cfgU, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
        .then(function(r){ return r.text(); })
        .then(function(t){
          var x = null; try { x = JSON.parse(t); } catch(e){}
          if (x) {
            if (D.variants == null) { D.variants = x.variantIndex || []; }
            if (x.previewRenders !== undefined) { D.previewRenders = x.previewRenders; }
            if (x.previewMasksByStyle !== undefined) { D.previewMasksByStyle = x.previewMasksByStyle; }
          }
          if (!D.variants) { D.variants = []; }
          __bootRest();
        })
        .catch(function(){ if (!D.variants) { D.variants = []; } __bootRest(); });
    } else {
      if (!D.variants) { D.variants = []; }
      __bootRest();
    }
  }
  while (q.length){ boot(q.shift()); }
})();
